import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
//import RaisedButton from 'material-ui/RaisedButton';
import Toggle from 'material-ui/Toggle';
import Grid from '@material-ui/core/Grid';
import InputMask from 'react-input-mask';
import { Link } from 'react-router';
import { Col, Row} from 'reactstrap';
import { Input, Alert, Label, FormGroup, Button} from 'reactstrap';
import readXlsxFile from 'read-excel-file';
import { Styles, Colors, tableStyles } from '../../../styles/theme';

import axios from 'axios';
import urlBase from '../../../url-base';
import { FaStepBackward } from "react-icons/fa";
import pdfResumoPropostaPJ from '../../relatorio/resumo_proposta_pj';

class CompanyList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      titlePage:"",
      data: 'loading',
      showTable: false,
      IsReenviarEmail: false,
      companyId:'',

      cityList: [],
      districtList: [],
      addressTypeList: [],
      stateList: [],
      score:  {
        classe: '',
        titulo:'',
        pontos:'',
        descricao:''

      },
      modalAnalyzingOpen: false,
      companyData: {
        imagesDoc: {
          usersTable: "",
          usersTableExt: "",
          rg: '',
          rg2: '',
          cpf: '',
          cnpj: '',
          address: '',
          physicalContract1: '',
          physicalContract2: '',
          physicalContract3: '',
          others: '',
          bairro: '',
          municipio: '',
          estado: '',
          plano: ''
        }
      },
      modalOpen: false,

      showActionField: false,
      showActionButton: false,
      showActionValidatingCompany: false,
      showActionInValidation: false,
      showActionAfterSales: false,
      showActionPJactivated: false,
      showActionOnActivation: false,
      showActionRegistrationRefused: false,
      showActionPendency: false,
      showActionPendencyField: false,
      showActionCancel: false,
      showActionCancelField: false,
      showActionS4: false,
      carenciaCoberturaS4Disable: true,

      modalAfterSalesOpen: false,
      modalAfterSalesLoading: false,
      modalAfterSalesActions: false,

      modalS4Open: false,
      modalS4Loading: false,
      modalS4Actions: false,
      modalS4Confirm: false,

      modalPendencyOpen: false,
      modalPendencyLoading: false,
      modalPendencyActions: false,
      pendencyList: [],

      modalCancellationsOpen: false,
      modalCancellationsLoading: false,
      modalCancellationsActions: false,
      cancellationsList: [],

      modalOnActivationOpen: false,
      modalOnActivationLoading: false,
      modalOnActivationActions: false,

      modalPJactivatedOpen: false,
      modalPJactivatedLoading: false,
      modalPJactivatedActions: false,

      modalRegistrationRefusedOpen: false,
      modalRegistrationRefusedLoading: false,
      modalRegistrationRefusedActions: false,

      modalInValidationOpen: false,
      modalInValidationLoading: false,
      modalInValidationActions: false,

      disabledCNPJ: false,
      disabledCPF: false,
      disabledAmountUsers: false,
      disableCostCenterS4: false,
      disableEffectiveDate: false,
      disableCarenciaCoberturaS4: false,
      disableAmountHolder: false,
      disableAmountDependent: false,
      disableAmountOrto: false,
      disableValuePlanHolder: false,
      disableValuePlanDependent: false,
      disableIncludesOrto: false,

      plansPjListS4: [],
      plansPjOrtoListS4: [],
      disabledPlansPjListS4: false,

      toggleChecked: false,
      colorBackImg: '#fff',

      confirmFmMensage: '',
      companyConfirm: '',

      showEditTable: false,
      usersTableSend: '',
      usersTableSendMsg: '',
    };

    this.styles = {
      error: {
        textAlign: 'center',
        fontSize: 18,
        color:'#ea0000',
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      zero: {
        textAlign: 'center',
        fontSize: 18,
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      table:{
        tableConfig:{
          ontFamily: "RubikRegular",
          textTransform: "uppercase",
        },
        theadTr:{
          fontFamily: "RubikRegular",
          textTransform: "uppercase",
        }
      },
      modal: {
        width: '85%',
        maxWidth: 'none',
      },
      fieldset: {
        border: '1px solid #f5aa00',
        padding: 10,
        marginTop: 15,
        paddingBottom: 25,
        borderRadius: 5
      },
      legend: {
        width: 'auto',
        fontSize: 20,
        position: 'relative',
        marginLeft: 15,
        padding: '0 5px'
      },
      input: {
        width: '100%'
      },     
      label: {
        margin: 0,
        marginTop: 10,
      },
      col: {
        marginTop: 0,
        paddingBottom: 0
      },
      closeBtn: {
        float: 'right',
        width: 25,
        cursor: 'pointer',
        position: 'relative',
        bottom: 15,
        left: 5
      },
      doc: {
        width: 150,
        height: 100,
        padding: '.25rem',
        backgroundColor: '#fff',
        border: '1px solid #dee2e6',
        borderRadius: '.25rem',
        cursor: 'pointer'
      },
      docPdf: {
        width: 150,
        height: 100,
        padding: '.25rem',
        backgroundColor: '#fff',
        cursor: 'pointer',
        marginTop: 5
      },
      titleDoc: {
        margin: 0
      },
      penEdit: {
        cursor: 'pointer',
        padding: 10
      }
    };

    // Campos obrigatórios
    this.errorField = {
      
    };
    this.downloadPDF = this.downloadPDF.bind(this);
    this.openPDF = this.openPDF.bind(this);    
    this.verificarScore = this.verificarScore.bind(this);
    this.reenviarEmail = this.reenviarEmail.bind(this);
    //this.reenviarUsuarios = this.reenviarUsuarios(this);
  }
  reenviarUsuarios(id) {

    var funcionarioCadastro =  localStorage.getItem('dental_codeS4') ;
    
    let dataSend = {
      company : id,
      funcionarioCadastro : funcionarioCadastro
    }

    axios.post(urlBase.loopBack + 'APIS4s/NovoUsuarioPJ', dataSend)
      .then(() => {
        alert("Planilha reenviada");

      })
      .catch(function (error) {
        alert("Erro ao reenviar planilha: " + error);
      }.bind(this));
  }
  downloadPDF()  {

    let state = this.state;

    var municipio = state.cityList.find( lista => lista.Id === state.companyData.city );
    state.companyData.municipio = municipio.Nome;

    var estado = state.stateList.find( lista => lista.Id === state.companyData.state );
    state.companyData.estado = estado.Sigla;

    var bairro = state.districtList.find( lista => lista.Id === state.companyData.district );
    state.companyData.bairro = bairro.Nome;     

    var plano = state.plansPjListS4.find( lista => lista.codeS4 === state.companyData.planS4 );
    state.companyData.plano = plano.name; 
    
    
    pdfResumoPropostaPJ(state.companyData, "download");
  }

  // reenviarEmail da empresa
  reenviarEmail(e) {
    e.preventDefault();

    let dataSend = {
      id: this.state.companyId
    };

    axios.post(urlBase.loopBack + 'Companies/SendEmailCompanyCreated', dataSend)
      .then(() => {
        alert("O e-mail de confirmação foi reenviado. Atenção: Peça para o cliente verificar a caixa de spam ou promoções, caso ele não tenha recebido.");

      })
      .catch(function (error) {
        alert("Erro ao reenviar Email: " + error);
      }.bind(this));
  }  
  // Implementar botão score

  verificarScore()  {
    let state = this.state;
    axios.get(urlBase.loopBack + 'APIS4s/VerificaScoreCNPJ?cnpj='+ state.companyData.cnpj ) 
    .then((result) => {

      let state = this.state;
      state.score.classe =  result.data.ocorrencias.score.score.classe;
      state.score.pontos  = result.data.ocorrencias.score.score.pontos;
      state.score.titulo = result.data.ocorrencias.score.score.faixa.titulo;
      state.score.descricao = result.data.ocorrencias.score.score.faixa.descricao;
      
      this.setState(state);
    })
    .catch(function (error) {    
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      }    
      alert("Atenção! A consulta não está disponível nesse momento. Tente novamente mais tarde." );
    });  
  }
  openPDF()  {
    let state = this.state;

    var municipio = state.cityList.find( lista => lista.Id === state.companyData.city );
    state.companyData.municipio = municipio.Nome;

    var estado = state.stateList.find( lista => lista.Id === state.companyData.state );
    state.companyData.estado = estado.Sigla;

    var bairro = state.districtList.find( lista => lista.Id === state.companyData.district );
    if (bairro === undefined)
      state.companyData.bairro = 'Indefinido'
    else
      state.companyData.bairro = bairro.Nome;     
    

    var plano = state.plansPjListS4.find( lista => lista.codeS4 === state.companyData.planS4 );
    state.companyData.plano = plano.name;  
    pdfResumoPropostaPJ(state.companyData,"visualizar");
  }
  
  complementarInformacoes() {

  //  {"where":{"codeS4": 1055, "type":"PJ"}}   

  }
  componentWillMount() {
    // Pega a lista de tipos de endereço
    axios.get(urlBase.loopBack + 'APIS4s/tipoLogradouro')
    .then((result) => {
      let state = this.state;
      state.addressTypeList = result.data; // Tipo logradouro

      // Pega a lista de estados
      axios.get(urlBase.loopBack + 'APIS4s/UFs')
      .then((result) => {
        // Estados
        state.stateList = result.data;

        // Pega a lista de pendências
        axios.get(urlBase.loopBack + 'Pendencies')
        .then((result) => {
          // Pendências
          state.pendencyList = result.data;

          // Pega a lista de cancelamentos
          axios.get(urlBase.loopBack + 'Cancellations')
          .then((result) => {
            // Cancelamentos
            state.cancellationsList = result.data;

            // Pega a lista de planosPJ
            axios.get(urlBase.loopBack + 'Plans?filter={"where":{"type":"PJ"}}')
            .then((result) => {
              let state = this.state;

              for (let i = 0; i < result.data.length; i++) {
                //if (result.data[i].value.length == 0) {
                  if (result.data[i].name.indexOf("ORTO") != -1 ) {
                    state.plansPjOrtoListS4.push(result.data[i]);
                  }
                    else
                      state.plansPjListS4.push(result.data[i]);

                //}
              }

              this.setState(state);

              this.setState(state);
              this.getFilterName();
              this.getData(true);
              this.getCurrentTimeServer();// Pega horário do servidor
            })
            .catch(function () {
              this.setError('Não conseguimos encontrar a lista com os planos');
            });
          })
          .catch(function () {
            this.setError('Não conseguimos encontrar a lista com os cancelamentos');
          });
        })
        .catch(function () {
          this.setError('Não conseguimos encontrar a lista com as pendências');
        });

      })
      .catch(function () {
        this.setError('Não conseguimos encontrar a lista dos estados');
      });
    })
    .catch(function () {
      this.setError('Não conseguimos encontrar a lista dos tipos de logradouro');
    });
  }

  getFilterName(){
    //pega o filtro para saber q nome exibir no titulo
    let state = this.state;

    if(this.props.table == "pjawaitingpayment")
      state.titlePage = "AGUARDANDO CONFIRMAÇÃO";
    else if(this.props.table == "pjonactivation")
      state.titlePage = "PEJOTA EM ATIVAÇÃO";
    else if(this.props.table == "pjactivated")
      state.titlePage = "PEJOTA ATIVADO";
    else if(this.props.table == "pjinvalidation")
      state.titlePage = "PEJOTA ATIVADO";
    else if(this.props.table == "pjaftersales")
      state.titlePage = "PEJOTA PÓS VENDA";
    else if(this.props.table == "pjpending")
      state.titlePage = "PENDENTE";
    else if(this.props.table == "pjdeployed60days")
      state.titlePage = "IMPLANTADOS ÚLTIMOS 60 DIAS";
    else if(this.props.table == "pjcanceled60days")
      state.titlePage = "CANCELADOS ÚLTIMOS 60 DIAS";
    else if(this.props.table == "all")
      state.titlePage = "TODAS AS EMPRESAS";
    else
      state.titlePage = "NÃO INDENTIFICADO";

    this.setState(state);
  }

  getData(table=false) {
    // Para o tipo dos dados da tabela
    let typeBox = this.props.table;
    let url = urlBase.loopBack + 'Companies/listByUser';
    let dataSend = {
      user: localStorage.getItem('dental_u'),
      content: typeBox,
    };
    if (url.length > 0) {
      axios.post(url, dataSend)
      .then((response) => {
        let state = this.state;

        if (response.data.length > 0)
          state.data = response.data;
        else
          state.data = 'zero';

        if (table == true && state.showTable == false) {
          state.showTable = true;

          $(document).ready( function () {
            $('#table_id').DataTable({
              "language": {
                "url": urlBase.client + "assets/plugins/datatables/Portuguese-Brasil.lang"
              },
              "order": [[0, "desc"]],
              lengthMenu: [
                [10, 25, 50, 100, -1],
                ['10', '25', '50', 100, 'Todas']
              ],
              columnDefs: [
                {className: 'mdl-data-table__cell--non-numeric'},
                { type: 'date-uk', targets: 0 },
              ]
            });
          });
        }

        this.setState(state);

      })
      .catch(function () {
        let state = this.state;
        state.data = 'error';
        this.setState(state);
      }.bind(this));
    }
    else {
      let state = this.state;
      state.data = 'zero';
      this.setState(state);
    }
  }

  beforeDetails(companyId) {
    let url = urlBase.loopBack + 'Companies/getDocsByCompany';
    this.setState(this.state); 
    // Para gerar resumo de proposta com mais de 60 dias, utilizar a linha comentada
    let dataPost = {
      id: companyId
      // id : "62c842a4f3adfc631041e549"
    };

    axios.post(url, dataPost)
    .then((response) => {
      let state = this.state;
      state.companyData = response.data;
      console.log(response.data)
      state.IsReenviarEmail = (state.companyData.status == "AGUARDANDO PAGAMENTO")
      state.companyId = companyId;
      state.score.classe = '';
      state.score.pontos = '';
      state.score.titulo = '';
      state.score.descricao = '';

      // Paulo - colocar aqui 
      /*
      if (localStorage.getItem('dental_y') == 'PJCADASTRO' ) {
        alert("cadastro");
        axios.get(urlBase.loopBack + 'APIS4s/VerificaScoreCNPJ?cnpj='+state.companyData.cnpj ) 
        .then((result) => {
  
          alert(state.companyData.cnpj);
          alert(result.data.ocorrencias.score.score.classe);
         // state.score.classe = 'N';
       //   state.score.titulo = 'N';
       //   state.score.descricao = 'N';        
          this.state.score.classe = result.data.ocorrencias.score.score.classe;
          this.state.score.pontos = result.data.ocorrencias.score.score.pontos;
          this.state.score.titulo = result.data.ocorrencias.score.score.faixa.titulo;
          this.state.score.descricao = result.data.ocorrencias.score.score.faixa.descricao;        
  
        })
        .catch(function (erro) {
          alert("Atenção! Informe o seguinte erro ao administrador: " + erro);
        });         

      } else {
        alert("Não cadasttro");
      }
      */


      // Caso a company ainda não tiver confirmado
      if (response.data.companyConfirm == null) {
        state.companyConfirm = 'Aguardando confirmação da empresa.';
      }

      this.setState(state);

      this.details();

      // Se estiver em analise
      /* if (response.data.analyzing && response.data.analyzing == true) {
        document.getElementById('row_company_'+companyId).style.backgroundColor = '#f8d7da';
        this.handleModalAnalyzingOpen(companyId);
      }
      // Se não estiver em analise
      else {
        url = urlBase.loopBack + 'Companies/upsertWithWhere?where={"id":"'+companyId+'"}';
        let updateCompany = {
          analyzing: true
        };

        axios.post(url, updateCompany)
        .then((response2) => {
          this.details(response2.data);
        })
        .catch(function () {
          alert('Problema encontrado ao atualizar a proposta');
        }.bind(this));
      } */
    })
    .catch(function () {
      alert('Problema encontrado ao buscar a proposta ');
    }.bind(this));
  }

  handleModalAnalyzingOpen() {
    let state = this.state;
    state.modalAnalyzingOpen = true;
    this.setState(state);
  }

  handleModalAnalyzingClose(details=false) {
    let state = this.state;
    state.modalAnalyzingOpen = false;
    this.setState(state);

    if (details == true)
      this.details();
  }

  details() {
    this.rulesOfActions();

    let state = this.state;
    state.modalOpen = true;
    this.setState(state);

    // Atualiza a cidade
    this.getCity();
  }

  getCity() {
    let dataPost = {
      'idUF': parseInt(this.state.companyData.state)
    };

    // Pega a lista de cidades
    axios.post(urlBase.loopBack + 'APIS4s/Municipios', dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;
      this.setState(state);
      // Pega os bairros
      this.getDistrict();
    })
    .catch(function (erro) {
      alert(erro);
    });
  }

  getDistrict() {
    let dataPost = {
      'idCity': parseInt(this.state.companyData.city)
    };
    // Pega a lista oa bairros
    axios.post(urlBase.loopBack + 'APIS4s/Bairros', dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;
      this.setState(state);
      document.getElementById('i_district').value = this.state.companyData.district;
    })
    .catch(function (erro) {
      alert(erro);
    });
  }

  handleModalClose() {
    this.setState({modalOpen: false, errorCheck: false});
    this.getData(false);
  }

  updateField(id) {
    let state = this.state;

    if (id == 'includesOrto')
      state.companyData[id] = !state.companyData[id];
    else {
      if (document.getElementById('i_'+id).value != '-1')
        state.companyData[id] = document.getElementById('i_'+id).value;
    }

    this.setState(state);
  }

  updateDB(field) {
    let dataSubmit = {};

    dataSubmit[field] = this.state.companyData[field];
    console.log(this.state.companyData)
    axios.post(urlBase.loopBack + 'Companies/upsertWithWhere?where={"id":"'+ this.state.companyData.id +'"}', dataSubmit)
    .then(() => {
      
    })
    .catch(function () {
      alert('Erro ao salvar dados');
    });
  }

  getAddress() {
    let valueCep = '';

    document.getElementById('loading_address').style.display = 'inline-block';
    valueCep = document.getElementById('i_cep').value;

    // Verifica o tamanho do cep
    if (valueCep.length >= 8) {
      let dataPost = {
        'cep': valueCep
      };

      // Pega o endereço
      axios.post(urlBase.loopBack + 'APIS4s/Endereco', dataPost)
      .then((result) => {
        if (result.data != null) {
          // Atualiza a lista de cidades e de bairros
          let state = this.state;
          state.cityList = [];
          state.districtList = [];
          state.companyData.addressType = document.getElementById('i_addressType').value = result.data.IdTipoLogradouro;
          state.companyData.address = document.getElementById('i_address').value = result.data.Logradouro;
          state.companyData.state = document.getElementById('i_state').value = result.data.IdUf;



          this.setState(state);

          // Salva no banco
          this.updateDB('addressType');
          this.updateDB('address');
          this.updateDB('state');

          this.getCityEdit();

          // Seta cidade
          let interval = setInterval(function () {
            document.getElementById('i_addressType').value = result.data.IdTipoLogradouro;
            if (document.getElementById('i_city').length > 1) {
              document.getElementById('i_city').value = result.data.IdMunicipio;
              let state = this.state;
              state.companyData.city = result.data.IdMunicipio;
              this.setState(state);
              clearInterval(interval);
              this.getDistrictEdit();

              // Salva no banco
              this.update('city');

              // Seta bairro
              let interval2 = setInterval(function () {
                if (document.getElementById('i_district').length > 1) {
                  document.getElementById('i_district').value = result.data.IdBairro;
                  let state = this.state;
                  state.companyData.district = result.data.IdBairro;
                  this.setState(state);
                  clearInterval(interval2);

                  // Salva no banco
                  this.update('district');

                  document.getElementById('i_addressNumber').focus();
                  document.getElementById('loading_address').style.display = 'none';
                }
              }.bind(this), 100);
            }
          }.bind(this), 100);
        }
        else
          document.getElementById('loading_address').style.display = 'none';
      })
      .catch(function (erro) {
        document.getElementById('loading_address').style.display = 'none';
        alert(erro);
      });
    }
    else
      document.getElementById('loading_address').style.display = 'none';
  }

  getCityEdit() {
    let chosenState = 0;
    chosenState = document.getElementById('i_state').value;

    let dataPost = {
      'idUF': parseInt(chosenState)
    };

    // Pega a lista de cidades
    axios.post(urlBase.loopBack + 'APIS4s/Municipios', dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;

      this.setState(state);
    })
    .catch(function (erro) {
      alert(erro);
    });
  }

  getDistrictEdit() {
    let chosenCity = 0;
    chosenCity = document.getElementById('i_city').value;

    let dataPost = {
      'idCity': parseInt(chosenCity)
    };

    // Pega a lista de bairros
    axios.post(urlBase.loopBack + 'APIS4s/Bairros', dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;
      this.setState(state);
    })
    .catch(function (erro) {
      alert(erro);
    });
  }

  validateCpfFM(id) {
    let cpf = document.getElementById('i_'+id).value.replace(/[^0-9]/g,'');
    let test = true;
    let add = 0, i = 0, rev = 0;

    if (cpf.length != 11 || 
        cpf == "00000000000" || 
        cpf == "11111111111" || 
        cpf == "22222222222" || 
        cpf == "33333333333" || 
        cpf == "44444444444" || 
        cpf == "55555555555" || 
        cpf == "66666666666" || 
        cpf == "77777777777" || 
        cpf == "88888888888" || 
        cpf == "99999999999"){
      test = false;
    }
    else {
      // Valida 1° digito	
      for (i=0; i < 9; i ++)
        add += parseInt(cpf.charAt(i)) * (10 - i);	
        rev = 11 - (add % 11);	
        if (rev == 10 || rev == 11){		
          rev = 0;
        }
        if (rev != parseInt(cpf.charAt(9))){		
          test = false;          	
        }
      // Valida 2° digito	
      add = 0;
      for (i = 0; i < 10; i ++){	
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);	
      if (rev == 10 || rev == 11){
        rev = 0;
      }
      if (rev != parseInt(cpf.charAt(10))){
        test = false;
      }
    }

    if (test == true) {
      document.getElementById("alert_"+id).style.display = "none";
      this.updateDB(id);
    }
    else
      document.getElementById("alert_"+id).style.display = "block";
  }

  confirmationForm (e, value) {
    let state = this.state;
    state.companyData.chanelConfirm = value;
    this.setState(state);
    this.updateDB('chanelConfirm');
  }

  typeOfContractChange(e, value) {
    let state = this.state;
    state.companyData.typeOfContract = value;
    this.setState(state);
    this.updateDB('typeOfContract');
  }
  tipoTributacaoChange(e, value) {
    let state = this.state;
    state.companyData.tipoTributacao = value;
    this.setState(state);
    this.updateDB('tipoTributacao');
  }
  amountUsersChange(e, value) {
    let state = this.state;
    state.companyData.amountUsers = value;
    this.setState(state);
    this.updateDB('amountUsers');
  }

  rulesOfActions() {
    let state = this.state;
    let typeUser = localStorage.getItem('dental_y');
    let statusCompany = this.state.companyData.status;

    state.showActionField = false;
    state.showActionButton = false;
    state.showActionValidatingCompany = false;
    state.showActionInValidation = false;
    state.showActionAfterSales = false;
    state.showActionPJactivated = false;
    state.showActionOnActivation = false;
    state.showActionRegistrationRefused = false;
    state.showActionPendency = false;
    state.showActionCancel = false;
    state.showActionS4 = false;
    state.disableEffectiveDate = true;
    state.carenciaCoberturaS4Disable = true;

    if (typeUser != 'PJCADASTRO') {
      state.disabledPlansPjListS4 = true;
      state.showEditTable = true;
    }

    if (typeUser == 'SALESMAN' || typeUser == 'BROKER' || typeUser == 'BACKOFFICE') {
      state.disabledCNPJ = true;
      state.disabledCPF = true;
      state.disabledAmountUsers = true;
      state.disableCostCenterS4 = true;
      state.disableEffectiveDate = true;
      state.disableCarenciaCoberturaS4 = true;
      state.disableAmountHolder = true;
      state.disableAmountDependent = true;
      state.disableAmountOrto = true;
      state.disableValuePlanHolder = true;
      state.disableValuePlanDependent = true;
      state.disableIncludesOrto = true;
    }
    if (typeUser == 'PJCADASTRO') {
      state.disableEffectiveDate = false;
      state.carenciaCoberturaS4Disable = false;

      if (statusCompany == 'EM VALIDAÇÃO') { // PEJOTA EM ATIVAÇÃO
        state.showActionField = true;
        state.showActionS4 = true;
        state.showActionCancel = true;
        state.showActionPendency = true;


      }
      if (statusCompany == 'VALIDANDO EMPRESA') { // PEJOTA EM ATIVAÇÃO
        state.showActionField = true;
        //state.showActionAfterSales = true;
        state.showActionPendency = true;
        state.showActionCancel = true;
        state.showActionInValidation = false;
        // Paulo Incluir Enviar para o S4e
        state.showActionS4 = true;

      }
      else if (statusCompany == 'PENDENTE') {
        state.showActionField = true;
        state.showActionButton = true;
        state.showActionAfterSales = true;
        state.showActionInValidation = true;
        state.showActionCancel = true;
      }
      else if (statusCompany == 'CANCELADO') {
        state.showActionField = true;
        state.showActionButton = true;
        state.showActionPendency = true;
        state.showActionAfterSales = true;
        state.showActionInValidation = true;
                
      }
    }// Fim PJCADASTRO
    else if (typeUser == 'REGISTER') {
      state.disableEffectiveDate = false;
      state.disabledCNPJ = true;
      state.disabledCPF = true;
      state.disableAmountHolder = true;
      state.disableAmountDependent = true;
      state.disableAmountOrto = true;
      state.disableValuePlanHolder = true;
      state.disableValuePlanDependent = true;
      state.disableIncludesOrto = true;

      if (statusCompany == 'EM VALIDAÇÃO') {
        if (this.state.companyData.afterSales == false) {
          state.showActionField = true;
          state.showActionAfterSales = true;
          state.showActionPendency = true;
          state.showActionCancel = true;
          //state.showActionS4 = true;
        }
      }
      else if (statusCompany == 'PENDENTE') {
        state.showActionField = true;
        state.showActionAfterSales = true;
        state.showActionCancel = true;
        //state.showActionS4 = true;
      }
      else if (statusCompany == 'CANCELADO') {
        state.showActionField = true;
        state.showActionAfterSales = true;
        //state.showActionS4 = true;
        state.showActionPendency = true;
      }
    }// Fim CADASTRO
    else if (typeUser == 'AFTER SALES') {
      state.carenciaCoberturaS4Disable = false;
      state.disabledCNPJ = true;
      state.disabledCPF = true;

      if (statusCompany == 'EM VALIDAÇÃO') {
        if (this.state.companyData.afterSales == true) {
          state.showActionField = true;
          state.showActionPendency = true;
          state.showActionCancel = true;
          state.showActionInValidation = true;
          state.showActionS4 = true;
        }
      }
      if (statusCompany == 'PENDENTE') {
        state.showActionField = true;
        state.showActionCancel = true;
        state.showActionInValidation = true;
        state.showActionS4 = true;
      }
      else if (statusCompany == 'CANCELADO') {
        state.showActionField = true;
        state.showActionPendency = true;
        state.showActionInValidation = true;
        state.showActionS4 = true;
      }
    }
    // paulo
    else if (typeUser == 'SALESMAN' || typeUser == 'BROKER' || typeUser == 'BACKOFFICE') {
      if (statusCompany == 'AGUARDANDO PAGAMENTO') {
        if (this.state.companyData.chanelConfirm == 'EMAIL' && this.state.companyData.salesmanConfirm != null) {
          state.showActionField = false;
        }
        else {
          state.showActionField = true;
          state.showActionCancel = true;
          if (this.state.companyData.companyConfirm != null)
             state.showActionOnActivation = true;
        }
      }
      else if (statusCompany == 'PENDENTE') {
        state.showActionField = true;
        state.showActionInValidation = true;
        state.showActionCancel = true;
      }
      else if (statusCompany == 'CANCELADO') {
        state.showActionField = true;
        state.showActionInValidation = true;
      }
    }

    this.setState(state);
  }

  chooseAction() {
    let state = this.state;
    let action = document.getElementById('id_action').value;

    if (action > 0)
      state.showActionButton = true;
    else
      state.showActionButton = false;

    // Quando a escolha for inserir pendência
    if (action == 3)
      state.showActionPendencyField = true;
    else
      state.showActionPendencyField = false;

    // Quando a escolha for cancelar proposta
    if (action == 4)
      state.showActionCancelField = true;
    else
      state.showActionCancelField = false;

    this.setState(state);
  }

  chooseActionConfirm() {
    let action = document.getElementById('id_action').value;

    if (action > 0) {
      // Envia para S4
      if (action == 1)
        this.handleModalS4Open();

      // Envia para Pós Venda
      else if (action == 2)
        this.handleModalAfterSavesOpen();

      // Para inserir pedência
      else if (action == 3)
        this.handleModalPendencyOpen();

      // Cancelar proposta
      else if (action == 4)
        this.handleModalCancellationsOpen();

      // Cadastro recusado
      else if (action == 6)
        this.handleModalRegistrationRefusedOpen();

      // PEJOTA em ativação (VALIDANDO EMPRESA)
      else if (action == 7)
        this.handleModalOnActivationOpen();

      // PEJOTA ativado
      else if (action == 8)
        this.handleModalPJactivatedOpen();

      // Em Validação
      else if (action == 9)
        this.handleModalInValidationOpen();

      else
        alert('Em desenvolvimento');

      // Enviar para análise
      //if (action == 5)
        //this.confirm(false, true);
    }
  }

  handleModalCancellationsOpen () {
    this.setState({modalCancellationsOpen: true});
  }

  handleModalCancellationsClose() {
    this.setState({modalCancellationsOpen: false});
  }

  actionCancellationsDB() {
    let state = this.state;
    state.modalCancellationsLoading = true;
    state.modalCancellationsActions = true;
    this.setState(state);

    let cancelId = document.getElementById('id_CancelField').value;

    if (cancelId.length > 0) {
      let dataPost = {
        status: "CANCELADO",
        cancellationId: cancelId,
        analyzing: false,
        salesmanId: this.state.companyData.salesmanId,
      };
      let url = urlBase.loopBack + 'Companies/upsertWithWhere?where={"id":"' + this.state.companyData.id + '"}';

      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.modalCancellationsLoading = false;
        state.modalCancellationsActions = false;
        state.modalCancellationsOpen = false;
        state.modalOpen = false;
        this.setState(state);
        this.getData(false);
      })
      .catch((error) => {
        let state = this.state;
        state.modalCancellationsLoading = false;
        this.setState(state);
        alert(error);
      });
    }
    else
      alert('Escolha uma pendência');
  }

  handleModalS4Open() {
    this.setState({modalS4Open: true});
  }

  handleModalS4Close() {
    this.setState({modalS4Open: false});
  }

  handleModalAfterSavesOpen() {
    this.setState({modalAfterSalesOpen: true});
  }

  handleModalAfterSalesClose() {
    this.setState({modalAfterSalesOpen: false});
  }

  sendAfterSales() {
    let state = this.state;
    state.modalAfterSalesLoading = true;
    state.modalAfterSalesActions = true;
    this.setState(state);

    let url = urlBase.loopBack + 'Companies/upsertWithWhere?where={"id":"'+ this.state.companyData.id + '"}';
    let dataPost = {
      afterSales: true,
      analyzing: false,
      status: 'EM VALIDAÇÃO',
    };

    axios.post(url, dataPost)
    .then(() => {
      let state = this.state;
      state.modalAfterSalesLoading = false;
      state.modalAfterSalesActions = false;
      state.modalAfterSalesOpen = false;
      state.modalOpen = false;
      this.setState(state);
      this.getData(false);
    })
    .catch(function (error) {
      alert(error);
    });
  }

  sendS4() {
    let url = urlBase.loopBack + 'APIS4s/NovaEmpresa';
    var funcionarioCadastro =  localStorage.getItem('dental_codeS4') ;
    

    let dataSend = {
      company: this.state.companyData.id,
      funcionarioCadastro : funcionarioCadastro
    };

    let state = this.state;
    state.modalS4Loading = true;
    state.modalS4Actions = true;
    this.setState(state);

    axios.post(url, dataSend)
    .then((result) => {

      if (result.data.error != undefined && result.data.error == true) {
        let state = this.state;
        state.modalS4Loading = false;
        state.modalS4Actions = false;
        state.modalS4Open = false;
        this.setState(state);

        alert(result.data.message);
      }
      else {
        let dataSendEmail = {
          id: this.state.companyData.id
        };
  
        axios.post(urlBase.loopBack + 'Companies/SendEmailActive', dataSendEmail)
        .then(() => {
          let state = this.state;
          state.modalS4Loading = false;
          state.modalS4Actions = false;
          state.modalS4Open = false;
          state.modalOpen = false;
          this.setState(state);
          this.getData(false);
        })
        .catch(function () {
          alert('Problema encontrado ao enviar email para a empresa');
        });
      }
    })
    .catch(function () {
      alert('Problema encontrado ao salvar empresa no S4E');
    }.bind(this));
  }

  handleModalPendencyOpen() {
    this.setState({modalPendencyOpen: true});
  }

  handleModalPendencyClose() {
    this.setState({modalPendencyOpen: false});
  }

  actionPendencyDB() {
    let state = this.state;
    state.modalPendencyLoading = true;
    state.modalPendencyActions = true;
    this.setState(state);

    let pendencyId = document.getElementById('id_PendencyField').value;

    if (pendencyId.length > 0) {
      let dataPost = {
        id: this.state.companyData.id,
        pendencyId: pendencyId,
      };
      let url = urlBase.loopBack + 'Companies/SendEmailPendency';

      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.modalPendencyLoading = false;
        state.modalPendencyActions = false;
        state.modalPendencyOpen = false;
        state.modalOpen = false;
        this.setState(state);
        this.getData(false);
      })
      .catch((error) => {
        let state = this.state;
        state.modalPendencyLoading = false;
        this.setState(state);
        alert(error);
      });
    }
    else
      alert('Escolha uma pendência');
  }

  handleModalOnActivationOpen() {
    this.setState({modalOnActivationOpen: true});
  }

  handleModalOnActivationClose() {
    this.setState({modalOnActivationOpen: false});
  }

  actionOnActivationDB() {
    // Paulo - aqui onde tá o problema

    let state = this.state;
    state.modalOnActivationLoading = true;
    state.modalOnActivationActions = true;
    this.setState(state);

    if (this.state.companyData.status == 'AGUARDANDO PAGAMENTO') {

      // Tipo de confirmação por email - Paulo (retirado para normalizar máquina de estado)
      //  if (this.state.companyData.chanelConfirm == 'EMAIL') {

        let dataSendEmailOnActivation = {
          id: this.state.companyData.id,
          type: 'SALESMAN'
        };

        let state = this.state;
        state.data = 'loading';
        this.setState(state);

        axios.post(urlBase.loopBack + 'Companies/SendEmailOnActivation', dataSendEmailOnActivation)
        .then(() => {
          let state = this.state;
          // Verifica a confirmação da company
          // (Confirmado)
          if (this.state.companyData.companyConfirm != null) {
            state.modalOnActivationLoading = false;
            state.modalOnActivationActions = false;
            state.modalOnActivationOpen = false;
            state.modalOpen = false;
            this.setState(state);
            this.getData(false);
          }
          else {
            state.modalOnActivationLoading = false;
            state.modalOnActivationActions = false;
            state.modalOnActivationOpen = false;
            state.companyConfirm = "Aguardando confirmação da empresa";
            state.showActionField = false;
            state.confirm = true;
            state.modalOpen = false;
            this.setState(state);
            this.getData(false);
          }
        })
        .catch(function (error) {
          alert(error);
        });
                    //}
              /* CÓDIGO RETIRADO PARA TRATAR DESVIO DO FLUXO - PAULO 28/07/2022 */
                /*    else {
                      let dataPost = {
                        status: "EM VALIDAÇÃO",
                        analyzing: false
                      };

                      axios.post(urlBase.loopBack + 'Companies/update?where={"id":"'+this.state.companyData.id+'"}', dataPost)
                      .then(() => {
                        let state = this.state;
                        state.confirm = true;
                        state.errorCheck = false;

                        /* if (action)
                          state.showActionField = false; 
                        */
                      /*
                        state.modalOpen = false;
                        this.setState(state);
                        this.getData(false);
                      })
                      .catch(function (error) {
                        alert(error);
                      });
                    } */ 
    }
    else {
      let url = urlBase.loopBack + 'Companies/upsertWithWhere?where={"id":"'+ this.state.companyData.id + '"}';
      let dataPost = {
        analyzing: false,
        status: 'VALIDANDO EMPRESA',
      };

      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.modalOnActivationLoading = false;
        state.modalOnActivationActions = false;
        state.modalOnActivationOpen = false;
        state.modalOpen = false;
        this.setState(state);
        this.getData(false);
      })
      .catch(function (error) {
        alert(error);
      });
    }
  }

  handleModalPJactivatedOpen() {
    this.setState({modalPJactivatedOpen: true});
  }

  handleModalPJactivatedClose() {
    this.setState({modalPJactivatedOpen: false});
  }
  // ativar cadastro
  actionPJactivatedDB() {
    let state = this.state;
    state.modalPJactivatedLoading = true;
    state.modalPJactivatedActions = true;
    this.setState(state);

    let url = urlBase.loopBack + 'Companies/upsertWithWhere?where={"id":"'+ this.state.companyData.id + '"}';
    let dataPost = {
      analyzing: false,
      status: 'PEJOTA ATIVADO',
    };

    axios.post(url, dataPost)
    .then(() => {
      let state = this.state;
      state.modalPJactivatedLoading = false;
      state.modalPJactivatedActions = false;
      state.modalPJactivatedOpen = false;
      state.modalOpen = false;
      this.setState(state);
      this.getData(false);
    })
    .catch(function (error) {
      alert(error);
    });
  }

  handleModalRegistrationRefusedOpen() {
    this.setState({modalRegistrationRefusedOpen: true});
  }

  handleModalRegistrationRefusedClose() {
    this.setState({modalRegistrationRefusedOpen: false});
  }
  // Cadastro recusado cancelamento
  actionRegistrationRefusedDB() {
    let state = this.state;
    state.modalRegistrationRefusedLoading = true;
    state.modalRegistrationRefusedActions = true;
    this.setState(state);

    let url = urlBase.loopBack + 'Companies/upsertWithWhere?where={"id":"'+ this.state.companyData.id + '"}';
    let dataPost = {
      analyzing: false,
      status: 'CADASTRO RECUSADO',
    };

    axios.post(url, dataPost)
    .then(() => {
      let state = this.state;
      state.modalRegistrationRefusedLoading = false;
      state.modalRegistrationRefusedActions = false;
      state.modalRegistrationRefusedOpen = false;
      state.modalOpen = false;
      this.setState(state);
      this.getData(false);
    })
    .catch(function (error) {
      alert(error);
    });
  }

  handleModalInValidationOpen() {
    this.setState({modalInValidationOpen: true});
  }

  handleModalInValidationClose() {
    this.setState({modalInValidationOpen: false});
  }

  actionInValidationDB() {

    let state = this.state;
    state.modalInValidationLoading = true;
    state.modalInValidationActions = true;
    this.setState(state);

    let url = urlBase.loopBack + 'Companies/upsertWithWhere?where={"id":"'+ this.state.companyData.id + '"}';
    let dataPost = {
      analyzing: false,
      afterSales: false,
      status: 'EM VALIDAÇÃO',
    };

    axios.post(url, dataPost)
    .then(() => {
      let state = this.state;
      state.modalInValidationLoading = false;
      state.modalInValidationActions = false;
      state.modalInValidationOpen = false;
      state.modalOpen = false;
      this.setState(state);
      this.getData(false);
    })
    .catch(function (error) {
      alert(error);
    });
  }

  onToggle(event, isInputChecked) {
    let state = this.state;
    state.toggleChecked = isInputChecked;

    if (isInputChecked == true)
      state.colorBackImg = '#fff3cd';
    else
      state.colorBackImg = '#fff';

    this.setState(state);
  }

  fileToBase64(typeDoc) {
    /*
    * @type pode ser: "cpf", "rg", "rg2"
    */
   console.log("Entrei aqui")
   
    let reader = new FileReader();
    let file = document.getElementById('doc_'+typeDoc).files[0];

    reader.onloadend = function() {
      let dataSubmit = {
        id: this.state.companyData.id,
        imagesDocId: this.state.companyData.imagesDoc.id,
        imagesDocs: {
          cpf: '',
          rg: '',
          cnh: '',
          rg2: '',
          cnpj: '',
          address: '',
          others: '',
          usersTable: '',
          usersTableExt: '',
        }
      };

      dataSubmit.imagesDocs[typeDoc] = reader.result;
      if (typeDoc == 'usersTable') {
        dataSubmit.imagesDocs.usersTableExt = 'xlsx';
        this.validateUsersTable(dataSubmit, file);
      }
      else {
        axios.post(urlBase.loopBack + 'Companies/saveDocsCompany', dataSubmit)
        .then((response) => {
          let state = this.state;
          state.companyData.imagesDoc = response.data;
          this.setState(state);
        })
        .catch(() => {
          alert('Erro ao salvar imagem do '+typeDoc);
        });
      }

    }.bind(this);
    reader.readAsDataURL(file);
  }

  validateUsersTable(dataSubmit=null, file) {
    let validate = true;
    let state = this.state;
    state.usersTableSend = 'validating';
    state.usersTableSendMsg = 'Validando...';
    this.setState(state);

    axios.get(urlBase.loopBack + 'Plans?filter={"where":{"usersTable":true}}')
    .then((result) => {
      let codeList = [];

      for (let i = 0; i < result.data.length; i++) {
        codeList.push(result.data[i].codeS4);
      }

      readXlsxFile(file).then((rows) => {
        // Planilha vazia
        if (rows.length <= 3) {
          state.usersTableSend = 'error';
          state.usersTableSendMsg = 'PLANILHA VAZIA - FAVOR PREENCHER ANTES DE ENVIAR';
          document.getElementById('doc_usersTable').value = "";
        }
        else {
          /*
          let nomeTit = 0;
          let nomeDep = 1;
          let cpf = 2;
          let dataNasc = 3;
          let tipoPlano = 4;
          let nomeMae = 5;
          let sexo = 6;
          let rg = 7;
          let emissaoRg = 8;
          let celular = 9;
          //let email = 10;
          let codigo = 11;
          */
          let nomeTit = 0;
          let nomeDep = 1;
          let parentesco = 2;
          let cpf = 3;
          //let cns = 4;
          let dataNasc = 5;
          let tipoPlano = 6;
          let nomeMae = 7;
          let sexo = 8;
          //let rg = 9;
          //let emissaoRg = 10;
          let celular = 11;
          let codigo = 13;

          for (let i = 3; i < rows.length; i++) {
            if (rows[i][nomeTit] == null && rows[i][nomeDep] == null) {
              state.usersTableSend = 'error';
              state.usersTableSendMsg = 'FUNCIONÁRIO SEM NOME DE TITULAR E SEM NOME DE DEPENDENTE';
              document.getElementById('doc_usersTable').value = "";
              validate = false;
              break;
            }

            if (rows[i][codigo] == null) {
              state.usersTableSend = 'error';
              state.usersTableSendMsg = 'CÓDIGO DO PLANO É OBRIGATÓRIO';
              document.getElementById('doc_usersTable').value = "";
              validate = false;
              break;
            }
            else {
              if (codeList.indexOf(rows[i][codigo]) < 0) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][codigo] + ' - NÃO É UM CÓDIGO DE PLANO VÁLIDO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }
            }

            if (rows[i][tipoPlano] == null) {
              state.usersTableSend = 'error';
              state.usersTableSendMsg = 'O TIPO DE PLANO É OBRIGATÓRIO PARA TITULARES E DEPENDENTES';
              document.getElementById('doc_usersTable').value = "";
              validate = false;
              break;
            }
            else {
              let tipoPlanoList = ['clínico', 'clinico', 'orto'];
              // Não é um tipo de plano válido
              if (tipoPlanoList.indexOf(rows[i][tipoPlano].toLowerCase()) < 0) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][tipoPlano] + ' - NÃO É UM TIPO DE PLANO VÁLIDO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }
            }

            // Linha do titular
            if (rows[i][nomeTit] != null && rows[i][nomeDep] == null) {
              // Verifica nome completo
              if (rows[i][nomeTit].indexOf('.') >= 0) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeTit].toUpperCase()+' - NOME COMPLETO SEM ABREVIAÇÃO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }

              // Nome com acentuação
              if (this.checkAccentuation(rows[i][nomeTit]) == false) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeTit].toUpperCase()+' - NÃO PERMITIDO ACENTUAÇÃO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }

              // Sem CPF
              if (rows[i][cpf] == null) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeTit].toUpperCase()+' - SEM CPF INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }

              // Sem parentesco
              if (rows[i][parentesco] == null) {
                state.usersTableSend = 'error';
                state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM GRAU DE PARENTESCO INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                break;
              } else {
                let listaCodParentesco = [1, 3, 4, 6, 8, 10 ]
                if ( listaCodParentesco.indexOf(rows[i][parentesco]) === -1 ) {
                  state.usersTableSend = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - CÓDIGO DO GRAU DE PARENTESCO INVÁLIDO';
                  document.getElementById('doc_usersTable').value = "";
                  break;                    
                }
              }
             // Sem CNS
             /*
              if (rows[i][cns] == null) {
                state.usersTableSend = 'error';
                state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM CNS INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                break;
              }                               
              // Sem RG
              if (rows[i][rg] == null) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeTit].toUpperCase()+' - SEM RG INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }
              // Sem orgão expedidor do RG
              if (rows[i][emissaoRg] == null) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeTit].toUpperCase()+' - SEM ORGÃO EXPEDIDOR DO RG INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }
                */

              // Sem data de nascimento
              if (rows[i][dataNasc] == null) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeTit].toUpperCase()+' - SEM DATA DE NASCIMENTO INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }
              // Titular maior ou igual a 18 anos
              else {
                let age = new Date(rows[i][dataNasc]);
                if (this.calculateAge(age.getFullYear(), age.getMonth()+1,age.getDate()) < 18 ) {
                  state.usersTableSend = 'error';
                  state.usersTableSendMsg = rows[i][nomeTit].toUpperCase()+' - DEVERÁ SER MAIOR DE IDADE (18 ANOS)';
                  document.getElementById('doc_usersTable').value = "";
                  validate = false;
                  break;
                }
              }
              // Sem nome da mãe
              if (rows[i][nomeMae] == null) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeTit].toUpperCase()+' - SEM NOME DA MÃE INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }
              // Sem sexo
              if (rows[i][sexo] == null) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeTit].toUpperCase()+' - SEM SEXO INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }
              else {
                if (rows[i][sexo].toUpperCase() != 'M' && rows[i][sexo].toUpperCase() != 'F') {
                  state.usersTableSend = 'error';
                  state.usersTableSendMsg = rows[i][nomeTit].toUpperCase()+' COM SEXO INVÁLIDO. ACEITO: F/M';
                  document.getElementById('doc_usersTable').value = "";
                  validate = false;
                  break;
                }
              }
              // Sem celular
              if (rows[i][celular] == null) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeTit].toUpperCase()+' - SEM CELULAR INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }
            }
            // Linha dos dependentes
            else {
              // Verifica acentuação
              if (rows[i][nomeDep].indexOf('.') >= 0) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeDep].toUpperCase()+' - NOME COMPLETO SEM ABREVIAÇÃO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }

              // Nome com acentuação
              if (this.checkAccentuation(rows[i][nomeDep]) == false) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeDep].toUpperCase()+' - NÃO PERMITIDO ACENTUAÇÃO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }
              
              // Sem data de nascimento
              if (rows[i][dataNasc] == null) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeDep].toUpperCase()+' - SEM DATA DE NASCIMENTO INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }
              else {
                // Apartir de 10 anos CPF obrigatório
                let age = new Date(rows[i][dataNasc]);
                if (this.calculateAge(age.getFullYear(), age.getMonth()+1,age.getDate()) >= 10 && rows[i][cpf] == null) {
                  state.usersTableSend = 'error';
                  state.usersTableSendMsg = rows[i][nomeDep].toUpperCase()+' - A PARTIR DE 10 ANOS CPF OBRIGATÓRIO';
                  document.getElementById('doc_usersTable').value = "";
                  validate = false;
                  break;
                }
              }
              // Sem nome da mãe
              if (rows[i][nomeMae] == null) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeDep].toUpperCase()+' - SEM NOME DA MÃE INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }

              // Sem CNS
              // if (rows[i][cns] == null) {
              //   state.usersTableSend = 'error';
              //   state.usersTableError = rows[i][nomeDep].toUpperCase()+' - SEM CNS INFORMADO';
              //   document.getElementById('doc_usersTable').value = "";
              //   break;
              // }          
              // Sem parentesco
              if (rows[i][parentesco] == null) {
                state.usersTableSend = 'error';
                state.usersTableError = rows[i][nomeDep].toUpperCase()+' - SEM GRAU DE PARENTESCO INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                break;
              } else {
                let listaCodParentesco = [1, 3, 4, 6, 8, 10 ]
                if ( listaCodParentesco.indexOf(rows[i][parentesco]) === -1 ) {
                  state.usersTableSend = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - CÓDIGO DO GRAU DE PARENTESCO INVÁLIDO';
                  document.getElementById('doc_usersTable').value = "";
                  break;                    
                }
              } 
              // Sem sexo
              if (rows[i][sexo] == null) {
                state.usersTableSend = 'error';
                state.usersTableSendMsg = rows[i][nomeDep].toUpperCase()+' - SEM SEXO INFORMADO';
                document.getElementById('doc_usersTable').value = "";
                validate = false;
                break;
              }
              else {
                if (rows[i][sexo].toUpperCase() != 'M' && rows[i][sexo].toUpperCase() != 'F') {
                  state.usersTableSend = 'error';
                  state.usersTableSendMsg = rows[i][nomeDep].toUpperCase()+' COM SEXO INVÁLIDO. ACEITO: F ou M';
                  document.getElementById('doc_usersTable').value = "";
                  validate = false;
                  break;
                }
              }
            }
          }

          if (dataSubmit != null && validate == true) {
            axios.post(urlBase.loopBack + 'Companies/saveDocsCompany', dataSubmit)
            .then((response) => {
              let state = this.state;
              state.usersTableSend = '';
              state.companyData.imagesDoc = response.data;
              this.setState(state);
            })
            .catch(function () {
              alert('Problema ao salvar planilha');
              let state = this.state;
              state.usersTableSend = 'error';
              state.usersTableSendMsg = 'PROBLEMA AO SALVAR PLANILHA';
              document.getElementById('doc_usersTable').value = "";
              this.setState(state);
            }.bind(this));
          }
        }

        this.setState(state);
      });
    })
    .catch(function () {
      alert('Problema encontrado ao buscar lista de planos PEJOTA');
      let state = this.state;
      state.usersTableSend = 'error';
      state.usersTableSendMsg = 'PROBLEMA AO BUSCAR LISTA DE CÓDIGOS DOS PLANOS';
      document.getElementById('doc_usersTable').value = "";
      this.setState(state);
    }.bind(this));
  }
  
  checkAccentuation(text) {
    let accentuationList = "áàãâäéèêëíìîïóòõôöúùûüÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜ";

    for (let i = 0; i < text.length; i++) {
      if (accentuationList.indexOf(text[i]) >= 0) {
        return false;
      }
    }

    return true;
  }

  calculateAge(anoAniv, mesAniv, diaAniv) {
    let anoAtual = this.state.currentTimeServer.year,
        mesAtual = this.state.currentTimeServer.month,
        diaAtual = this.state.currentTimeServer.day,
        qtsAnos = anoAtual - anoAniv;

    anoAniv = +anoAniv;
    mesAniv = +mesAniv;
    diaAniv = +diaAniv;

    if (mesAtual < mesAniv || mesAtual == mesAniv && diaAtual < diaAniv)
        qtsAnos--;

    return qtsAnos < 0 ? 0 : qtsAnos;
  }

  getCurrentTimeServer() {
    // Pega a data atual do servidor
    axios.post(urlBase.loopBack + 'Sales/currentTime')
    .then((response) => {
      let state = this.state;
      state.currentTimeServer = response.data;
      this.setState(state);
    })
    .catch(function () {
      alert('Problema encontrado ao pegar data do servidor');
    });
  }

  openWindow(image, title) {
    let url = urlBase.client + 'spinimage?im=' + image;

    window.open(
      url,
      title,
      "location,status,scrollbars,resizable,width=800, height=800"
    );
  }
getStatusLabel (item) {
  if (item.status === "EM VALIDAÇÃO") {
    return item.afterSales === true ? 'PÓS VENDA' : item.status;
  }
  
  if (item.status === "VALIDANDO EMPRESA") {
    return "PEJOTA EM ATIVAÇÃO";
  }
  
  if (item.status === "AGUARDANDO PAGAMENTO") {
    return "AGUARDANDO CONFIRMAÇÃO";
  }
  
  return item.status;
}
  getStatusConfig(item) {
    //const userType = localStorage.getItem('dental_y');
    //const isAfterSales = item.afterSales;
    const status = item.status;

    // Objeto inicial com valores padrão (Caso nada combine)
    let config = {
      text: status,
      bg: '#EEE', 
      color: '#333'
    };

  if (status === 'ATIVO') {
      config.text = 'ATIVO';
      config.bg = Colors.statusAtivoBg;   // Existe no seu theme
      config.color = Colors.statusAtivoText; // Existe no seu theme
    } 
    else if (status === 'CANCELADO' || status === 'INATIVO') {
      config.text = status;
      config.bg = Colors.statusInativoBg;   // Existe no seu theme
      config.color = Colors.statusInativoText; // Existe no seu theme
    }
    else if (status === 'PENDENTE' || status === 'PAGAMENTO PENDENTE') {
      config.text = status === 'PAGAMENTO PENDENTE' ? 'AGUARDANDO CONFIRMAÇÃO' : status;
      config.bg = Colors.warning;
      config.color = Colors.white;
    }

    return config;
  }
  goBack() {
    window.history.back();
  }

  render() {

    const actions = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalS4Actions}
        onTouchTap={this.handleModalS4Close.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalS4Actions}
        onTouchTap={this.sendS4.bind(this, true)}
      />,
    ];
    const actionsAnalyzing = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        onTouchTap={this.handleModalAnalyzingClose.bind(this, false)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        onTouchTap={this.handleModalAnalyzingClose.bind(this, true)}
      />
    ];
    const actionsAfterSales = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalAfterSalesActions}
        onTouchTap={this.handleModalAfterSalesClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalAfterSalesActions}
        onTouchTap={this.sendAfterSales.bind(this)}
      />,
    ];
    const actionsCancellations = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalCancellationsActions}
        onTouchTap={this.handleModalCancellationsClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalCancellationsActions}
        onTouchTap={this.actionCancellationsDB.bind(this)}
      />,
    ];
    const actionsOnActivation = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalOnActivationActions}
        onTouchTap={this.handleModalOnActivationClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalOnActivationActions}
        onTouchTap={this.actionOnActivationDB.bind(this)}
      />,
    ];
    const actionsPJactivated = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalPJactivatedActions}
        onTouchTap={this.handleModalPJactivatedClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalPJactivatedActions}
        onTouchTap={this.actionPJactivatedDB.bind(this)}
      />,
    ];
    const actionsRegistrationRefused = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalRegistrationRefusedActions}
        onTouchTap={this.handleModalRegistrationRefusedClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalRegistrationRefusedActions}
        onTouchTap={this.actionRegistrationRefusedDB.bind(this)}
      />,
    ];
    const actionsPendency = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalPendencyActions}
        onTouchTap={this.handleModalPendencyClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalPendencyActions}
        onTouchTap={this.actionPendencyDB.bind(this)}
      />,
    ];
    const actionsInValidation = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.modalInValidationActions}
        onTouchTap={this.handleModalInValidationClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.modalInValidationActions}
        onTouchTap={this.actionInValidationDB.bind(this)}
      />,
    ];

    return (
      <div>
        <style>{tableStyles}</style>
        
        <Row>
          <Col xs="12" sm="12" md="3" lg="3" xl="3">
            <p onClick={this.goBack.bind(this)} style={{ cursor: 'pointer' }}> <FaStepBackward />  Voltar</p>
          </Col>
          <Col xs="12" sm="12" md="3" lg="3" xl="3">
          </Col>

          <Col xs="12" sm="12" md="3" lg="3" xl="3">

          </Col>
        </Row>
        <p className="title_panel_plans">{this.state.titlePage}</p>

        {
          this.state.data == 'loading' ? (
        <div style={{textAlign: 'center'}}>
          <CircularProgress />
          <p>Carregando...</p>
        </div>
          ) : (
            this.state.data == 'error' ? (
        <p style={this.styles.error}>
          Erro ao buscar dados.
        </p>
            ) : (
              this.state.data == 'zero' ? (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <Alert color='warning' style={{ fontSize: 13 }}>
                Nenhuma informação encontrada.
              </Alert>
            </div>
              ) : (
          <div>

            <table
              id="table_id"
              className="table-striped dataTable"
              style={{ width: '100%' }}
            >
              <thead>
                <tr style={this.styles.table.theadTr}>
                  <th>Nome Fantasia</th>
                  <th>Corretora</th>
                  <th>Vendedor</th>
                  <th>Status</th>
                </tr>
              </thead>

                <tbody>
                  {this.state.data.map((item, index) => {
                    const statusConfig = this.getStatusConfig(item);

                    return (
                      <tr
                        id={'row_company_' + item.id}
                        key={index}
                        className="row_table"
                        onClick={this.beforeDetails.bind(this, item.id)}
                        style={{ cursor: 'pointer' }}
                      >
                        <td data-label="Nome Fantasia">
                          {item.fantasyName}
                        </td>

                        <td data-label="Corretora">
                          {item.salesman.broker.user.name}
                        </td>

                        <td data-label="Vendedor">
                          {item.salesman.user.name}
                        </td>

                        <td data-label="Status">
                          <span
                            style={{
                              padding: '4px 12px',
                              borderRadius: '20px',
                              fontSize: '10px',
                              fontWeight: 'bold',
                              display: 'inline-block',
                              textAlign: 'center',
                              minWidth: '110px',
                              backgroundColor: statusConfig.bg,
                              color: statusConfig.color,
                              textTransform: 'uppercase'
                            }}
                          >
                            {this.getStatusLabel(item)}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>

            </table>
         
            <Dialog
              title="Confirmação"
              actions={actionsAnalyzing}
              modal={true}
              open={this.state.modalAnalyzingOpen}
            >
              <p>
                Esta empresa já está sendo analizada por outro operador.
                Caso prossiga poderá ocorrer duplicidade de inclusão.
                Deseja continuar mesmo assim?
              </p>
            </Dialog>

            <Dialog
             className="dialog-scroll-custom"
              title={
                <div>
                  Dados da Empresa
                  <img
                    style={this.styles.closeBtn}
                    src={urlBase.client+'/assets/images/icons/icon_close.png'}
                    onClick={this.handleModalClose.bind(this)}
                  />
                </div>
              }
              titleStyle={{textAlign:'center'}}
              bodyStyle={{padding: '0 10px 24px'}}
              actions={<span>&nbsp;</span>}
              modal={false}
              open={this.state.modalOpen}
              onRequestClose={this.handleModalClose.bind(this)}
              autoScrollBodyContent={true}
              contentStyle={this.styles.modal}
            >
              <div>
                <div style={{marginBottom: 25}}>
                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Forma de Confirmação
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <RadioButtonGroup
                          name="chanelConfirm"
                          onChange={this.confirmationForm.bind(this)}
                          valueSelected={this.state.companyData.chanelConfirm}
                        >

                          <RadioButton
                            value="EMAIL"
                            label="Email"
                            disabled={true}
                          />
                        </RadioButtonGroup>
                      </Grid>
                    </Grid>
                  </fieldset>
                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Tipo de Tributação
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <RadioButtonGroup
                          name="typeOfContract"
                          onChange={this.tipoTributacaoChange.bind(this)}
                          valueSelected={this.state.companyData.tipoTributacao}
                        >
                          <RadioButton
                            value="1"
                            label="Não Optante"
                            //disabled={true}
                          />
                          <RadioButton
                            value="2"
                            label="Lucro Real"
                            //disabled={true}
                          />
                          <RadioButton
                            value="3"
                            label="Lucro Presumido"
                            //disabled={true}
                          />
                          <RadioButton
                            value="4"
                            label="Simples Nacional"
                            //disabled={true}
                          />                          
                        </RadioButtonGroup>
                      </Grid>
                    </Grid>
                  </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Empresa Contratante
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}>CNPJ</label>
                        <InputMask
                          id="i_cnpj"
                          style={this.styles.cnpj}
                          mask="99999999/9999-99"
                          className="form-control"
                          type="text"
                          defaultValue={this.state.companyData.cnpj}
                          onChange={this.updateField.bind(this, 'cnpj')}
                          onBlur={this.updateDB.bind(this, 'cnpj')}
                          disabled={this.state.disabledCNPJ}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}>Data de Abertura.</label>
                        <Input
                          id="i_openingDate"
                          style={this.styles.input}
                          type="date"
                          defaultValue={this.state.companyData.openingDate}
                          onChange={this.updateField.bind(this, 'openingDate')}
                          onBlur={this.updateDB.bind(this, 'openingDate')}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                        <label style={this.styles.label}>Nome Fantasia</label>
                        <Input
                          id="i_fantasyName"
                          style={this.styles.input}
                          type="text"
                          defaultValue={this.state.companyData.fantasyName}
                          onChange={this.updateField.bind(this, 'fantasyName')}
                          onBlur={this.updateDB.bind(this, 'fantasyName')}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <label style={this.styles.label}>Nome Empresarial</label>
                        <Input
                          id="i_businessName"
                          style={this.styles.input}
                          type="text"
                          defaultValue={this.state.companyData.businessName}
                          onChange={this.updateField.bind(this, 'businessName')}
                          onBlur={this.updateDB.bind(this, 'businessName')}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}>CEP
                          <i
                            id="loading_address"
                            style={{ display: 'none', marginLeft: 10, width: 15 }}
                            className="fa fa-spinner fa-spin">
                            &nbsp;
                          </i>
                        </label>
                        <InputMask
                          id="i_cep"
                          style={this.styles.cep}
                          mask="99.999-999"
                          className="form-control"
                          type="text"
                          defaultValue={this.state.companyData.cep}
                          onChange={this.updateField.bind(this, 'cep')}
                          onBlur={this.getAddress.bind(this)}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label}>Logradouro</label>
                        <Input
                          id="i_addressType"
                          type="select"
                          className="form-control"
                          defaultValue={this.state.companyData.addressType}
                          onChange={this.updateField.bind(this, 'addressType')}
                          onBlur={this.updateDB.bind(this, 'addressType')}
                        >
                          <option value="-1">Tipo</option>
                          {this.state.addressTypeList.map((item, index) =>
                            <option key={index} value={item.Id}>{item.Nome}</option>
                          )}
                        </Input>
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={5} lg={5}>
                        <label style={this.styles.label}>Endereço</label>
                        <Input
                          id="i_address"
                          style={this.styles.input}
                          type="text"
                          defaultValue={this.state.companyData.address}
                          onChange={this.updateField.bind(this, 'address')}
                          onBlur={this.updateDB.bind(this, 'address')}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label}>Número</label>
                        <Input
                          id="i_addressNumber"
                          style={this.styles.input}
                          type="text"
                          defaultValue={this.state.companyData.addressNumber}
                          onChange={this.updateField.bind(this, 'addressNumber')}
                          onBlur={this.updateDB.bind(this, 'addressNumber')}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}>Complemento</label>
                        <Input
                          id="i_addressComplement"
                          style={this.styles.input}
                          type="text"
                          defaultValue={this.state.companyData.addressComplement}
                          onChange={this.updateField.bind(this, 'addressComplement')}
                          onBlur={this.updateDB.bind(this, 'addressComplement')}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                        <label style={this.styles.label}>Estado</label>
                        <Input
                          id="i_state"
                          type="select"
                          className="form-control"
                          defaultValue={this.state.companyData.state}
                          onChange={this.updateField.bind(this, 'state')}
                          onBlur={this.updateDB.bind(this, 'state')}
                        >
                          <option value="-1">UF</option>
                          {this.state.stateList.map((item, index) =>
                            <option key={index} value={item.Id}>{item.Sigla}</option>
                          )}
                        </Input>
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}>Cidade</label>
                        <Input
                          id="i_city"
                          type="select"
                          className="form-control"
                          defaultValue={this.state.companyData.city}
                          onChange={this.updateField.bind(this, 'city')}
                          onBlur={this.updateDB.bind(this, 'city')}
                        >
                          <option value="-1">Cidade</option>
                          {this.state.cityList.map((item, index) =>
                            <option key={index} value={item.Id}>{item.Nome}</option>
                          )}
                        </Input>
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}>Bairro</label>
                        <Input
                          id="i_district"
                          type="select"
                          className="form-control"
                          defaultValue={this.state.companyData.district}
                          onChange={this.updateField.bind(this, 'district')}
                          onBlur={this.updateDB.bind(this, 'district')}
                        >
                          <option value="-1">Bairro</option>
                          {this.state.districtList.map((item, index) =>
                            <option key={index} value={item.Id}>{item.Nome}</option>
                          )}
                        </Input>
                      </Grid>
                    </Grid>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}>Telefone Fixo</label>
                        <InputMask
                          id="i_homePhone"
                          style={this.styles.input}
                          className="form-control"
                          mask="(99) 9999-9999"
                          type="text"
                          defaultValue={this.state.companyData.homePhone}
                          onChange={this.updateField.bind(this, 'homePhone')}
                          onBlur={this.updateDB.bind(this, 'homePhone')}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}>Celular 1</label>
                        <InputMask
                          id="i_cellPhone"
                          style={this.styles.input}
                          mask="(99) \9 9999-9999"
                          className="form-control"
                          type="text"
                          defaultValue={this.state.companyData.cellPhone}
                          onChange={this.updateField.bind(this, 'cellPhone')}
                          onBlur={this.updateDB.bind(this, 'cellPhone')}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}>Celular 2</label>
                        <InputMask
                          id="i_cellPhone2"
                          style={this.styles.input}
                          mask="(99) \9 9999-9999"
                          className="form-control"
                          type="text"
                          defaultValue={this.state.companyData.cellPhone2}
                          onChange={this.updateField.bind(this, 'cellPhone2')}
                          onBlur={this.updateDB.bind(this, 'cellPhone2')}
                        />
                      </Grid>
                    </Grid>
                  </fieldset>


                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Responsável Legal
                    </legend>
                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <label style={this.styles.label}>Nome Completo</label>
                        <Input
                          id="i_legalResponsible"
                          style={this.styles.input}
                          type="text"
                          defaultValue={this.state.companyData.legalResponsible}
                          onChange={this.updateField.bind(this, 'legalResponsible')}
                          onBlur={this.updateDB.bind(this, 'legalResponsible')}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}>RG</label>
                        <Input
                          id="i_legalResponsibleRg"
                          style={this.styles.input}
                          type="text"
                          defaultValue={this.state.companyData.legalResponsibleRg}
                          onChange={this.updateField.bind(this, 'legalResponsibleRg')}
                          onBlur={this.updateDB.bind(this, 'legalResponsibleRg')}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}>CPF</label>
                        <InputMask
                          id="i_legalResponsibleCpf"
                          style={this.styles.input}
                          mask="999.999.999-99"
                          className="form-control"
                          type="tel"
                          defaultValue={this.state.companyData.legalResponsibleCpf}
                          onChange={this.updateField.bind(this, 'legalResponsibleCpf')}
                          onBlur={this.validateCpfFM.bind(this, "legalResponsibleCpf")}
                          disabled={this.state.disabledCPF}
                        />
                        <Alert id="alert_legalResponsibleCpf" style={{display: 'none'}}>*Cpf inválido!</Alert>
                      </Grid>
                    </Grid>

                    <Grid container spacing={24}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <div style={{margin: '30px 0 16px'}}>
                          <Toggle
                            label="Editar"
                            labelPosition="right"
                            style={{float: 'right', width: 88}}
                            onToggle={this.onToggle.bind(this)}
                          />
                        </div>
                      </Grid>
                    {/** DOCUMENTOS ANEXADOS
                     * CNH
                    */}
                          {
                            /* Verificação segura contra null/undefined */
                            this.state.companyData &&
                            this.state.companyData.imagesDoc &&
                            this.state.companyData.imagesDoc.cnh &&
                            this.state.companyData.imagesDoc.cnh.length > 0 ? (  
                            <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                              <div
                                style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10}}
                              >

                                {
                                  this.state.toggleChecked == true ? (
                                    <div>
                                      <label htmlFor="doc_cnh" style={{cursor:'pointer'}}>
                                        <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                      </label>

                                      <input
                                        id="doc_cnh"
                                        style={{visibility:"hidden",position:'absolute',left: -9999}}
                                        type="file"
                                        name="cnh"
                                        onChange={this.fileToBase64.bind(this, 'cnh')}
                                      />
                                    </div>
                                  ) : ('')
                                }

                                <p style={this.styles.titleDoc}>CNH</p>
                                {
                                  /* Verificação segura contra null/undefined */
                                  this.state.companyData &&
                                  this.state.companyData.imagesDoc &&
                                  this.state.companyData.imagesDoc.cnh &&
                                  this.state.companyData.imagesDoc.cnh.length > 0 ? (                            

                                <a
                                  onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.rg, 'Imagem do CNH')}
                                  target="_blank">
                                  {
                                    this.state.companyData.imagesDoc.cnh.substr(this.state.companyData.imagesDoc.cnh.length - 3, this.state.companyData.imagesDoc.cnh.length).toLowerCase() == 'pdf' ? (
                                    <span>
                                      &nbsp;&nbsp;&nbsp;&nbsp;
                                      <i
                                        className="far fa-file-pdf fa-6x"
                                        style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                      >&nbsp;</i>
                                    </span>
                                    ) : (
                                  <img
                                    style={this.styles.doc}
                                  src={urlBase.loopBack + 'attachments/docs/download/' + this.state.companyData.imagesDoc.cnh}
                                  />
                                    )
                                  }
                                </a>
                                  ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                                }
                              </div>
                            </Grid>                                
                            ) : null
                          } 
{/* ################### Imagem RG ################### */}
                          {
                            this.state.companyData &&
                            this.state.companyData.imagesDoc &&
                            this.state.companyData.imagesDoc.rg &&
                            this.state.companyData.imagesDoc.rg.length > 0 ? (  
                            [
                          <Grid key="grid-doc-rg" item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                            <div
                              style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10}}
                            >

                              {
                                this.state.toggleChecked == true ? (
                                  <div>
                                    <label htmlFor="doc_rg" style={{cursor:'pointer'}}>
                                      <i style={this.styles.penEdit} className="fas fa-pen">{''}</i> 
                                    </label>

                                    <input
                                      id="doc_rg"
                                      style={{visibility:"hidden",position:'absolute',left: -9999}}
                                      type="file"
                                      name="rg"
                                      onChange={this.fileToBase64.bind(this, 'rg')}
                                    />
                                  </div>
                                ) : null
                              }

                              <p style={this.styles.titleDoc}>RG</p>
                              {/* todo */}
                              {  
                                  this.state.companyData.imagesDoc.rg != '' ? (
                              <a
                                onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.rg, 'Imagem do RG')}
                                target="_blank">
                                
                                {
                                    
                                  this.state.companyData.imagesDoc.rg.substr(this.state.companyData.imagesDoc.rg.length - 3, this.state.companyData.imagesDoc.rg.length).toLowerCase() == 'pdf' ? (
                                  <span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <i
                                      className="far fa-file-pdf fa-6x"
                                      style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                    >&nbsp;</i>
                                  </span>
                                  ) : (
                                <img
                                  style={this.styles.doc}
                                  src={urlBase.loopBack + 'attachments/docs/download/' + this.state.companyData.imagesDoc.rg}
                                  alt="Imagem do RG"
                                />
                                  )
                                }
                              </a>
                                ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                              }
                            </div>
                          </Grid>
                              ,
                              <Grid key="grid-doc-rg2" item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                                <div
                                  style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10}}
                                >

                                  {
                                    this.state.toggleChecked == true ? (
                                      <div>
                                        <label htmlFor="doc_rg2" style={{cursor:'pointer'}}>
                                          <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                        </label>

                                        <input
                                          id="doc_rg2"
                                          style={{visibility:"hidden",position:'absolute',left: -9999}}
                                          type="file"
                                          name="rg2"
                                          onChange={this.fileToBase64.bind(this, 'rg2')}
                                        />
                                      </div>
                                    ) : ('')
                                  }

                                  <p style={this.styles.titleDoc}>RG (VERSO)</p>
                                  {
                                    /* Verificação segura contra null/undefined */
                                    this.state.companyData &&
                                    this.state.companyData.imagesDoc &&
                                    this.state.companyData.imagesDoc.rg2 &&
                                    this.state.companyData.imagesDoc.rg2.length > 0 ? (                            

                                  <a
                                    onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.rg2, 'Imagem do verso da RG')}
                                    target="_blank">
                                    {
                                      this.state.companyData.imagesDoc.rg2.substr(this.state.companyData.imagesDoc.rg2.length - 3, this.state.companyData.imagesDoc.rg2.length).toLowerCase() == 'pdf' ? (
                                      <span>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <i
                                          className="far fa-file-pdf fa-6x"
                                          style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                        >&nbsp;</i>
                                      </span>
                                      ) : (
                                    <img
                                      style={this.styles.doc}
                                    src={urlBase.loopBack + 'attachments/docs/download/' + this.state.companyData.imagesDoc.rg2}
                                    />
                                      )
                                    }
                                  </a>
                                    ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                                  }
                                </div>
                              </Grid>  
                            ]                                                       
                            ) : null 
                          }

                    
{/* ################### Imagem CNPJ ################### */}
                      <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                        <div
                          style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10}}
                        >

                          {
                            this.state.toggleChecked == true ? (
                              <div>
                                <label htmlFor="doc_cnpj" style={{cursor:'pointer'}}>
                                  <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                </label>

                                <input
                                  id="doc_cnpj"
                                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                                  type="file"
                                  name="cnpj"
                                  onChange={this.fileToBase64.bind(this, 'cnpj')}
                                />
                              </div>
                            ) : ('')
                          }

                          <p style={this.styles.titleDoc}>CNPJ</p>
                          {
                            /* Verificação segura contra null/undefined */
                            this.state.companyData &&
                            this.state.companyData.imagesDoc &&
                            this.state.companyData.imagesDoc.cnpj &&
                            this.state.companyData.imagesDoc.cnpj.length > 0 ? (                            

                          <a
                            onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.cnpj, 'Imagem do CNPJ')}
                            target="_blank">
                            {
                              this.state.companyData.imagesDoc.cnpj.substr(this.state.companyData.imagesDoc.cnpj.length - 3, this.state.companyData.imagesDoc.cnpj.length).toLowerCase() == 'pdf' ? (
                              <span>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <i
                                  className="far fa-file-pdf fa-6x"
                                  style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                >&nbsp;</i>
                              </span>
                              ) : (
                            <img
                              style={this.styles.doc}
                             src={urlBase.loopBack + 'attachments/docs/download/' + this.state.companyData.imagesDoc.cnpj}
                            />
                              )
                            }
                          </a>
                            ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                          }
                        </div>
                      </Grid>    
{/* ################### Imagem endereco ################### */}
                      <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                        <div
                          style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10}}
                        >

                          {
                            this.state.toggleChecked == true ? (
                              <div>
                                <label htmlFor="doc_address" style={{cursor:'pointer'}}>
                                  <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                </label>

                                <input
                                  id="doc_address"
                                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                                  type="file"
                                  name="address"
                                  onChange={this.fileToBase64.bind(this, 'address')}
                                />
                              </div>
                            ) : ('')
                          }

                          <p style={this.styles.titleDoc}>ENDEREÇO</p>
                          {
                            /* Verificação segura contra null/undefined */
                            this.state.companyData &&
                            this.state.companyData.imagesDoc &&
                            this.state.companyData.imagesDoc.address &&
                            this.state.companyData.imagesDoc.address.length > 0 ? (                            

                          <a
                            onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.address, 'Imagem do ENDEREÇO')}
                            target="_blank">
                            {
                              this.state.companyData.imagesDoc.address.substr(this.state.companyData.imagesDoc.address.length - 3, this.state.companyData.imagesDoc.address.length).toLowerCase() == 'pdf' ? (
                              <span>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <i
                                  className="far fa-file-pdf fa-6x"
                                  style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                >&nbsp;</i>
                              </span>
                              ) : (
                            <img
                              style={this.styles.doc}
                             src={urlBase.loopBack + 'attachments/docs/download/' + this.state.companyData.imagesDoc.address}
                            />
                              )
                            }
                          </a>
                            ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                          }
                        </div>
                      </Grid>                                    
{/* ################### Imagem Outos ################### */}
                      <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                        <div
                          style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10}}
                        >

                          {
                            this.state.toggleChecked == true ? (
                              <div>
                                <label htmlFor="doc_others" style={{cursor:'pointer'}}>
                                  <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                </label>

                                <input
                                  id="doc_others"
                                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                                  type="file"
                                  name="others"
                                  onChange={this.fileToBase64.bind(this, 'others')}
                                />
                              </div>
                            ) : ('')
                          }

                          <p style={this.styles.titleDoc}>CONTRATO</p>
                          {
                            /* Verificação segura contra null/undefined */
                            this.state.companyData &&
                            this.state.companyData.imagesDoc &&
                            this.state.companyData.imagesDoc.others &&
                            this.state.companyData.imagesDoc.others.length > 0 ? (
                              <a
                                onClick={this.openWindow.bind(this, this.state.companyData.imagesDoc.others, 'Imagem de Outros')}
                                target="_blank">
                                {
                                  this.state.companyData.imagesDoc.others.substr(this.state.companyData.imagesDoc.others.length - 3, this.state.companyData.imagesDoc.others.length).toLowerCase() == 'pdf' ? (
                                  <span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <i
                                      className="far fa-file-pdf fa-6x"
                                      style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                    >&nbsp;</i>
                                  </span>
                                  ) : (
                                  <img
                                    style={this.styles.doc}
                                    src={urlBase.loopBack + 'attachments/docs/download/' + this.state.companyData.imagesDoc.others}
                                  />
                                  )
                                }
                              </a>
                            ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                          }
                        </div>
                      </Grid>


                    {/** aqui fim */}
                    </Grid>


                  </fieldset>


                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Gestão do Contrato
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={8} lg={8}>
                        <label style={this.styles.label}>Encarregado</label>
                        <Input
                          id="i_infoPersonInCharge"
                          style={this.styles.input}
                          type="text"
                          defaultValue={this.state.companyData.infoPersonInCharge}
                          onChange={this.updateField.bind(this, 'infoPersonInCharge')}
                          onBlur={this.updateDB.bind(this, 'infoPersonInCharge')}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}>Email</label>
                        <Input
                          id="i_infoEmailContact"
                          style={this.styles.input}
                          type="email"
                          defaultValue={this.state.companyData.infoEmailContact}
                          onChange={this.updateField.bind(this, 'infoEmailContact')}
                          onBlur={this.updateDB.bind(this, 'infoEmailContact')}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}>Telefone Fixo</label>
                        <InputMask
                          id="i_infoHomePhone"
                          style={this.styles.input}
                          className="form-control"
                          mask="(99) 9999-9999"
                          type="text"
                          defaultValue={this.state.companyData.infoHomePhone}
                          onChange={this.updateField.bind(this, 'infoHomePhone')}
                          onBlur={this.updateDB.bind(this, 'infoHomePhone')}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}>Celular 1</label>
                        <InputMask
                          id="i_infoCellPhone"
                          style={this.styles.input}
                          mask="(99) \9 9999-9999"
                          className="form-control"
                          type="text"
                          defaultValue={this.state.companyData.infoCellPhone}
                          onChange={this.updateField.bind(this, 'infoCellPhone')}
                          onBlur={this.updateDB.bind(this, 'infoCellPhone')}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}>Email</label>
                        <Input
                          id="i_infoEmailInvoice"
                          style={this.styles.input}
                          type="email"
                          defaultValue={this.state.companyData.infoEmailInvoice}
                          onChange={this.updateField.bind(this, 'infoEmailInvoice')}
                          onBlur={this.updateDB.bind(this, 'infoEmailInvoice')}
                        />
                      </Grid>
                    </Grid>
                  </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Quantidade de Usuários
                    </legend>

                    <Grid container spacing={24} style={{marginTop: 20, marginBottom:10}}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <Grid container spacing={24}>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>                            

                            <div>
                              <label style={this.styles.label}>Clínico Titular</label>
                              <Input
                                id="i_amountHolder"
                                style={this.styles.input}
                                type="tel"
                                defaultValue={this.state.companyData.amountHolder}
                                onChange={this.updateField.bind(this, 'amountHolder')}
                                onBlur={this.updateDB.bind(this, 'amountHolder')}
                                disabled={this.state.disableAmountHolder}
                              />
                            </div>

                            <div>
                              <label style={this.styles.label}>Clínico Dependente</label>
                              <Input
                                id="i_amountDependent"
                                style={this.styles.input}
                                type="tel"
                                defaultValue={this.state.companyData.amountDependent}
                                onChange={this.updateField.bind(this, 'amountDependent')}
                                onBlur={this.updateDB.bind(this, 'amountDependent')}
                                disabled={this.state.disableAmountDependent}
                              />
                            </div>

                            <div style={{marginTop: 25}}>
                              <FormGroup check>
                                <Label check>
                                  <Input
                                    id="i_includesOrto"
                                    type="checkbox"
                                    defaultChecked={this.state.companyData.includesOrto}
                                    onChange={this.updateField.bind(this, 'includesOrto')}
                                    onBlur={this.updateDB.bind(this, 'includesOrto')}
                                    disabled={this.state.disableIncludesOrto}
                                  />
                                  {' '}Inclui plano Orto
                                </Label>
                              </FormGroup>
                            </div>
                            { this.state.companyData.includesOrto ? (
                                <div>
                                <label style={this.styles.label}>Valor Plano Orto {this.state.companyData.valuePlanOrtoDivergent ? "(Vendedor)" : ''} </label>
                                <Input
                                  id="i_valuePlanoOrto"
                                  style={this.styles.input}
                                  type="tel"
                                  defaultValue={this.state.companyData.valuePlanOrto}
                                  disabled={true}
                                />
                                { this.state.companyData.valuePlanOrtoDivergent ? (
                                      <div>
                                        <label style={{textAlign: 'lef', color: 'rgb(237, 65, 52)'}}>Justificativa (valor divergente)</label>
                                        <Input
                                          id="i_justifyValueOrto"
                                          style={this.styles.input}
                                          type="textarea"
                                          defaultValue={this.state.companyData.justifyValueOrto}
                                          disabled={true}
                                        />
                                      </div>                                      
                                ) :
                                null                              
                                }                                 
                              </div> 
                            ) :
                             null
                              
                            }
                             
                          </Grid>

                          <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                            <div>
                              <label style={this.styles.label}>Valor Titular</label>
                              <Input
                                id="i_valuePlanHolder"
                                style={this.styles.input}
                                type="tel"
                                defaultValue={this.state.companyData.valuePlanHolder}
                                onChange={this.updateField.bind(this, 'valuePlanHolder')}
                                onBlur={this.updateDB.bind(this, 'valuePlanHolder')}
                                disabled={this.state.disableValuePlanHolder}
                              />
                            </div>

                            <div>
                              <label style={this.styles.label}>Valor Dependente</label>
                              <Input
                                id="i_valuePlanDependent"
                                style={this.styles.input}
                                type="tel"
                                defaultValue={this.state.companyData.valuePlanDependent}
                                onChange={this.updateField.bind(this, 'valuePlanDependent')}
                                onBlur={this.updateDB.bind(this, 'valuePlanDependent')}
                                disabled={this.state.disableValuePlanDependent}
                              />
                            </div>
                              { this.state.companyData.valuePlanDivergent ? (
                                  <div>
                                    <label style={{textAlign: 'lef', color: 'rgb(237, 65, 52)'}}>Justificativa (valor divergente)</label>
                                    <Input
                                      id="i_justifyValue"
                                      style={this.styles.input}
                                      type="textarea"
                                      defaultValue={this.state.companyData.justifyValue}
                                      disabled={true}
                                    />
                                  </div>
                              ) : null 
                              }
                            <div>
                              <label style={this.styles.label}>Orto (Titular/Dependente)</label>
                              <Input
                                id="i_amountOrto"
                                style={this.styles.input}
                                type="tel"
                                defaultValue={this.state.companyData.amountOrto}
                                onChange={this.updateField.bind(this, 'amountOrto')}
                                onBlur={this.updateDB.bind(this, 'amountOrto')}
                                disabled={this.state.disableAmountOrto}
                              />
                            </div>
                          </Grid>

                          {
                            this.state.companyData.imagesDoc != undefined ? (
                          <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                            <div style={{border: '1px solid #ccc', padding: '10px 8px'}}>
                              <div style={{margin: '0 auto', marginBottom: 10}}>
                                <label style={{textAlign: 'center', display: 'block'}}>Planilha com Relação de Usuários</label>
                              {
                                this.state.usersTableSend == 'validating' ? (
                                <div style={{textAlign: 'center'}}>
                                  <CircularProgress />
                                  <p>
                                    {this.state.usersTableSendMsg}
                                  </p>
                                </div>
                                ) : (
                                  this.state.usersTableSend == 'error' ? (
                                <div>
                                  <p style={{textAlign: 'center', color: 'rgb(237, 65, 52)'}}>
                                    {this.state.usersTableSendMsg}
                                  </p>                                
                                </div>
                                  ) : (
                                <div style={{textAlign: 'center'}}>
                                  <a
                                    href={urlBase.loopBack + 'attachments/docs/download/' + this.state.companyData.imagesDoc.usersTable}
                                    target="_blank"
                                    style={{color: '#606060'}}
                                  >
                                    <i className="far fa-file-excel fa-6x">{''}</i>
                                    <p>Baixar</p>
                                  </a>
                                </div>
                                  )
                                )
                              }
                              </div>

                            {
                              localStorage.getItem('dental_y') == 'PJCADASTRO' ? (
                              <div style={{textAlign: 'center'}}>
                                <hr/>
                                <label htmlFor="doc_usersTable"
                                  style={{cursor:'pointer', border: 10, boxSizing: 'border-box',
                                  display: 'inline-block', fontFamily: 'Roboto, sans-serif',
                                  textDecoration: 'none', margin: 0, padding: 0, outline: 'none', fontSize: 'inherit',
                                  fontWeight: 'inherit', position: 'relative', height: 43, lineHeight: 3,
                                  width: '250px', borderRadius: 2, backgroundColor: 'rgb(30, 136, 229)', textAlign: 'center'}}
                                >
                                  <span style={{color: '#fff'}}>Recarregar planilha...</span>
                                </label>

                                <input
                                  id="doc_usersTable"
                                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                                  type="file"
                                  name="usersTable"
                                  onChange={this.fileToBase64.bind(this, 'usersTable')}
                                />

                                <hr/>
                                {
                                this.state.companyData.status == 'ATIVO' && localStorage.getItem('dental_y') == 'PJCADASTRO' ? (
                                    <Link  onClick={this.reenviarUsuarios.bind(this, this.state.companyData.id)} >
                                        <div
                                        style={{cursor:'pointer', border: 10, boxSizing: 'border-box',
                                        display: 'inline-block', fontFamily: 'Roboto, sans-serif',
                                        textDecoration: 'none', margin: 0, padding: 0, outline: 'none', fontSize: 'inherit',
                                        fontWeight: 'inherit', position: 'relative', height: 40, lineHeight: 2,
                                        width: '200px', borderRadius: 2, backgroundColor: 'rgb(30, 136, 229)', textAlign: 'center', color: '#fff'}}
                                        >
                                          Reenviar usuários
                                        </div>
                                    </Link>   
                                  ) : ('') }
                              </div>
                              ) : ( this.state.companyData.status == 'PENDENTE' ? (
                              <div style={{textAlign: 'center'}}>
                                <hr/>
                                <label htmlFor="doc_usersTable"
                                  style={{cursor:'pointer', border: 10, boxSizing: 'border-box',
                                  display: 'inline-block', fontFamily: 'Roboto, sans-serif',
                                  textDecoration: 'none', margin: 0, padding: 0, outline: 'none', fontSize: 'inherit',
                                  fontWeight: 'inherit', position: 'relative', height: 43, lineHeight: 3,
                                  width: '250px', borderRadius: 2, backgroundColor: 'rgb(30, 136, 229)', textAlign: 'center'}}
                                >
                                  <span style={{color: '#fff'}}>Recarregar planilha...</span>
                                </label>

                                <input
                                  id="doc_usersTable"
                                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                                  type="file"
                                  name="usersTable"
                                  onChange={this.fileToBase64.bind(this, 'usersTable')}
                                />
                                </div>  ): ('')                                  
                              )
                            }
                            </div>
                          </Grid>
                            ) : ('')                     
                          }
                        </Grid>

                        <Grid container spacing={24}>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                            <label style={this.styles.label}>Plano Clínico</label>
                            <Input
                              id="i_planS4"
                              type="select"
                              className="form-control"
                              defaultValue={this.state.companyData.planS4}
                              onChange={this.updateField.bind(this, 'planS4')}
                              onBlur={this.updateDB.bind(this, 'planS4')}
                              disabled={this.state.disabledPlansPjListS4}
                            >
                              <option value="-1">Escolha um plano</option>
                              {this.state.plansPjListS4.map((item, index) =>
                                <option key={index} value={item.codeS4}>{item.name} - [ {item.tradeName} ]</option>
                              )}
                            </Input>
                          </Grid>

                          <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                            <label style={this.styles.label}>Plano Orto</label>
                            <Input
                              id="i_planOrtoS4"
                              type="select"
                              className="form-control"
                              defaultValue={this.state.companyData.planOrtoS4}
                              onChange={this.updateField.bind(this, 'planOrtoS4')}
                              onBlur={this.updateDB.bind(this, 'planOrtoS4')}
                              disabled={this.state.disabledPlansPjListS4}
                            >
                              <option value="-1">Escolha um plano</option>
                              {this.state.plansPjOrtoListS4.map((item, index) =>
                                <option key={index} value={item.codeS4}>{item.name} - [ {item.tradeName} ]</option>
                              )}
                            </Input>
                          </Grid>
                        </Grid>

                      </Grid>
                    </Grid>
                  </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Configurações do S4E
                    </legend>
                                
                    <Grid container spacing={24}>

                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}>Data de adesão</label>
                        <Input
                          id="i_data"
                          type="text"
                          className="form-control"
                          defaultValue={this.state.companyData.effectiveDate + '/' + this.state.companyData.effectiveDateMonth + '/' + this.state.companyData.effectiveDateYear}
                          disabled={true}
                        >
                        </Input>
                      </Grid>          

                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}>Centro de Custo</label>
                        <Input
                          id="i_costCenterS4"
                          type="select"
                          className="form-control"
                          defaultValue={this.state.companyData.costCenterS4}
                          onChange={this.updateField.bind(this, 'costCenterS4')}
                          onBlur={this.updateDB.bind(this, 'costCenterS4')}
                          disabled={this.state.disableCostCenterS4}
                        >
                          <option value="-1">Escolha</option>
                          <option key="1" value="1">JOÃO PESSOA</option>
                          <option key="2" value="2">CAMPINA GRANDE</option>
                          <option key="3" value="3">GUARABIRA</option>
                          <option key="4" value="4">SÃO LUIS</option>
                        </Input>
                      </Grid>                      

                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}>Dia da Vigência</label>
                        <Input
                          id="i_effectiveDate"
                          type="select"
                          className="form-control"
                          defaultValue={this.state.companyData.effectiveDate}
                          onChange={this.updateField.bind(this, 'effectiveDate')}
                          onBlur={this.updateDB.bind(this, 'effectiveDate')}
                          disabled={this.state.disableEffectiveDate}
                        >
                          <option value="-1">Escolha</option>
                          <option key="01" value="01">01</option>
                          <option key="02" value="02">02</option>
                          <option key="03" value="03">03</option>
                          <option key="04" value="04">04</option>
                          <option key="05" value="05">05</option>
                          <option key="06" value="06">06</option>
                          <option key="07" value="07">07</option>
                          <option key="08" value="08">08</option>
                          <option key="09" value="09">09</option>
                          <option key="10" value="10">10</option>
                          <option key="11" value="11">11</option>
                          <option key="12" value="12">12</option>
                          <option key="13" value="13">13</option>
                          <option key="14" value="14">14</option>
                          <option key="15" value="15">15</option>
                          <option key="16" value="16">16</option>
                          <option key="17" value="17">17</option>
                          <option key="18" value="18">18</option>
                          <option key="19" value="19">19</option>
                          <option key="20" value="20">20</option>
                          <option key="21" value="21">21</option>
                          <option key="22" value="22">22</option>
                          <option key="23" value="23">23</option>
                          <option key="24" value="24">24</option>
                          <option key="25" value="25">25</option>
                          <option key="26" value="26">26</option>
                          <option key="27" value="27">27</option>
                          <option key="28" value="28">28</option>
                          <option key="29" value="29">29</option>
                          <option key="30" value="30">30</option>
                        </Input>
                      </Grid>

                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}>Carência Cobertura</label>
                        <Input
                          id="i_carenciaCoberturaS4"
                          type="select"
                          className="form-control"
                          defaultValue={this.state.companyData.carenciaCoberturaS4}
                          onChange={this.updateField.bind(this, 'carenciaCoberturaS4')}
                          onBlur={this.updateDB.bind(this, 'carenciaCoberturaS4')}
                          disabled={this.state.disableCarenciaCoberturaS4}
                        >
                          <option value="-1">Escolha</option>
                          <option key="0" value="0">SEM CARÊNCIA</option>
                          <option key="1" value="1">PADRÃO DO PLANO DO USUÁRIO</option>
                        </Input>
                      </Grid>
                    </Grid>
                  </fieldset>


                  {
                    this.state.companyData.chanelConfirm == 'EMAIL' ? (
                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Confirmação da Proposta
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        {
                          this.state.companyConfirm.length > 0 ? (
                            this.state.companyConfirm
                          ) : ('Empresa já realizou a confirmação!')
                        }
                      </Grid>
                    </Grid>
                  </fieldset>
                    ) : ('')
                  }
                  {/*
                  {
                      localStorage.getItem('dental_y') == 'PJCADASTRO' || localStorage.getItem('dental_y') == 'REGISTER' ? (
<                 fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Score
                    </legend>

                    <Grid container spacing={24}>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={2}>
                                <div>
                                    <label style={this.styles.label}>Pontos</label>
                                    <Input
                                      id="i_justifyValue"
                                      style={this.styles.input}
                                      type="text"
                                      value={this.state.score.pontos }
                                      disabled={true}
                                    />
                                  </div>                              
                                <div>
                                    <label style={this.styles.label}>Classe</label>
                                    <Input
                                      id="i_justifyValue"
                                      style={this.styles.input}
                                      type="text"
                                      defaultValue={this.state.score.classe }
                                      value={this.state.score.classe }
                                      disabled={true}
                                    />
                                  </div>  
                                  <Col md='20' className='text-center'>
                                 <Link onClick={this.verificarScore} >
                                    <div className="button_plans">Verificar Score</div>
                                 </Link>                                  

                                </Col>                                   
                                      
                          </Grid>

                          <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={10}>

                                    <div>
                                      <label style={this.styles.label}>Título</label>
                                      <Input
                                        id="i_justifyValue"
                                        style={this.styles.input}
                                        type="text"
                                        value={this.state.score.titulo}
                                        disabled={true}
                                      />
                                    </div>   
                            
                                    <div>
                                      <label style={this.styles.label}>Descrição</label>
                                      <Input
                                        id="i_justifyValue"
                                        style={this.styles.input}
                                        type="textarea"
                                        value={this.state.score.descricao }
                                        disabled={true}
                                      />
                                    </div>                                                                         
                            </Grid>
                    
                  
                    </Grid>
                  </fieldset>
                    ) : ('')
                  }
                  */}
                  {
                    this.state.showActionField ? (
                  <Grid container spacing={24} style={{marginTop:30}}>
                    <Grid item style={{textAlign:'center'}} xs={12} sm={12} md={12} lg={12}>
                      <label style={this.styles.label}>Ações</label>
                      <Input
                        id="id_action"
                        style={{width: '50%', margin: '10px auto 0 auto'}}
                        type="select"
                        className="form-control"
                        onChange={this.chooseAction.bind(this)}
                      >
                        <option value={0}>Escolha uma opção</option>
                        {
                          this.state.showActionOnActivation == true ? (
                        <option value={7}>Enviar para Dental Center</option>
                          ) : ('')
                        }
                        {
                          this.state.showActionPJactivated == true ? (
                        <option value={8}>PEJOTA ativado</option>
                          ) : ('')
                        }
                        {
                          this.state.showActionInValidation == true ? (
                        <option value={9}>Enviar para Pré-cadastro</option>
                          ) : ('')
                        }
                        {
                          this.state.showActionS4 == true ? (
                        <option value={1}>Enviar para o S4</option>
                          ) : ('')
                        }
                        {
                          this.state.showActionAfterSales == true ? (
                        <option value={2}>Enviar para pós vendas</option>
                          ) : ('')
                        }
                        {
                          this.state.showActionPendency == true ? (
                        <option value={3}>Informar pendência</option>
                          ) : ('')
                        }
                        {
                          this.state.showActionCancel == true ? (
                        <option value={4}>Cancelar proposta</option>
                          ) : ('')
                        }
                        {
                          this.state.showActionRegistrationRefused == true ? (
                        <option value={6}>Cadastro recusado</option>
                          ) : ('')
                        }
                      </Input>
                    </Grid>

                {/* Campo para inserir cancelamento */
                  this.state.showActionCancelField == true ? (
                    <Grid item style={{textAlign:'center'}} xs={12} sm={12} md={12} lg={12}>
                      <div style={{textAlign: 'center'}}>
                        <label style={this.styles.label}>Escolha um cancelamento</label>
                        <Input
                          id="id_CancelField"
                          style={{width: '46%', margin: '10px auto 0 auto'}}
                          type="select"
                          className="form-control"
                        >
                        {this.state.cancellationsList.map((item, index) =>
                          <option key={index} value={item.id}>{item.code + ' - ' + item.name}</option>
                        )}
                        </Input>
                      </div>
                    </Grid>
                      ) : ('')
                    }

                    {/* Campo para inserir pendência */
                      this.state.showActionPendencyField == true ? (
                    <Grid item style={{textAlign:'center'}} xs={12} sm={12} md={12} lg={12}>
                      <div style={{textAlign: 'center'}}>
                        <label style={this.styles.label}>Escolha uma pendência</label>
                        <Input
                          id="id_PendencyField"
                          style={{width: '46%', margin: '10px auto 0 auto'}}
                          type="select"
                          className="form-control"
                        >
                        {this.state.pendencyList.map((item, index) =>
                          <option key={index} value={item.id}>{item.code + ' - ' + item.name}</option>
                        )}
                        </Input>
                      </div>
                    </Grid>
                      ) : ('')
                    }

                    {/* Botão de confirmação */
                    this.state.showActionButton == true ? (
                    <Grid item style={{textAlign:'center'}} xs={12} sm={12} md={12} lg={12}>
                       <Button
                          onClick={this.chooseActionConfirm.bind(this)}
                          style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
                        >
                        Confirmar
                        </Button>                       
                    </Grid>
                        ) : ('')
                      }
                  </Grid>
                    ) : ('')
                  }
                </div>
                <div style={{ 
                  marginTop: '30px', 
                  display: 'flex', 
                  justifyContent: 'flex-end', 
                  gap: '10px',
                  paddingBottom: '20px' 
                }}>
                  <Button
                    onClick={this.openPDF}
                    style={{ ...Styles.buttonSuccess, textTransform: 'none',fontWeight: 'bold' }}
                  >
                    Visualizar PDF
                  </Button>
                  <Button
                    onClick={this.downloadPDF}
                    style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
                  >
                    Download PDF
                  </Button>

                    {this.state.IsReenviarEmail && (
                      <Button
                        onClick={this.reenviarEmail.bind()}
                        style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
                      >
                        REENVIAR E-MAIL
                      </Button>
                    )}
               
                </div>                    
              </div>


            </Dialog>


            <Dialog
              title="Confirmação"
              actions={actionsAfterSales}
              modal={true}
              open={this.state.modalAfterSalesOpen}
            >
              {
                this.state.modalAfterSalesLoading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('Tem certeza que deseja enviar essa proposta para o Pós Venda?')
              }
            </Dialog>

            <Dialog
              title="Confirmação"
              actions={actions}
              modal={true}
              open={this.state.modalS4Open}
            >
              {
                this.state.modalS4Loading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('Tem certeza que deseja incluir essa empresa no sistema S4E?')
              }
            </Dialog>

            <Dialog
              title="Confirmação"
              actions={actionsCancellations}
              modal={true}
              open={this.state.modalCancellationsOpen}
            >
              {
                this.state.modalCancellationsLoading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('Tem certeza que deseja salvar a empresa como cancelada?')
              }
            </Dialog>

            <Dialog
              title="Confirmação"
              actions={actionsOnActivation}
              modal={true}
              open={this.state.modalOnActivationOpen}
            >
              {
                this.state.modalOnActivationLoading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('Tem certeza que deseja enviar essa empresa para um Analista Pejota?')
              }
            </Dialog>

            <Dialog
              title="Confirmação"
              actions={actionsPJactivated}
              modal={true}
              open={this.state.modalPJactivatedOpen}
            >
              {
                this.state.modalPJactivatedLoading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('Tem certeza que deseja marcar essa empresa como PEJOTA Ativado?')
              }
            </Dialog>

            <Dialog
              title="Confirmação"
              actions={actionsRegistrationRefused}
              modal={true}
              open={this.state.modalRegistrationRefusedOpen}
            >
              {
                this.state.modalRegistrationRefusedLoading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('Tem certeza que deseja marcar essa empresa como Recusada?')
              }
            </Dialog>

            <Dialog
              title="Confirmação"
              actions={actionsPendency}
              modal={true}
              open={this.state.modalPendencyOpen}
            >
              {
                this.state.modalPendencyLoading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('Tem certeza que deseja salvar a empresa como pendente?')
              }
            </Dialog>

            <Dialog
              title="Confirmação"
              actions={actionsInValidation}
              modal={true}
              open={this.state.modalInValidationOpen}
            >
              {
                this.state.modalInValidationLoading == true ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : ('Tem certeza que deseja enviar para Pré-cadastro?')
              }
            </Dialog>
          </div>
              )
            )
          )
        }
      </div>
    );

  }

}

CompanyList.propTypes = {
  table: PropTypes.string
};

export default CompanyList;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/RegisterCompany/CompanyList.js
 **/